import { useParams, Link } from "react-router-dom";
import { useEffect, useState, useRef, useCallback } from "react";
import APIs from "../../APIs";
import Sidebar from "./Sidebar";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import axios from "axios";
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  Polyline,
} from "@react-google-maps/api";
import ChatWidget from "../../components/ChatWidget";
import "../../index.css"; // <-- your override should be here
import { GOOGLE_MAP_KEY } from "../../Utils/Utils";
import qs from "qs";
import { useMyLocation } from "../../hooks/LocationContext";
import moment from "moment-timezone";
const containerStyle = {
  width: "100%",
  height: "400px",
  borderRadius: "15px",
};

const mapOptions = {
  streetViewControl: false,
  mapTypeControl: false,
  fullscreenControl: true,
  zoomControl: true,
};

const BookingDetails = () => {
  const { shipmentId } = useParams();
  const { location: currentLocation, loaded } = useMyLocation();
  console.log("current my location5", currentLocation);
  const [documents, setDocuments] = useState([]);
  const [docName, setDocName] = useState("");
  const [docDescription, setDocDescription] = useState("");
  const [docFile, setDocFile] = useState(null);
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [booking, setBooking] = useState(null);
  const [loading, setLoading] = useState(true);
  const [pickupAddress, setPickupAddress] = useState(null);
  const [dropoffAddress, setDropoffAddress] = useState(null);
  const [trackingData, setTrackingData] = useState(null);
  const [mainStatus, setMainStatus] = useState(null);
  const [stageStatus, setStageStatus] = useState([]);
  const [trackingLoading, setTrackingLoading] = useState(false);
  const [expandedStages, setExpandedStages] = useState({ 0: true }); // First stage expanded by default
  const [currentFlightInfo, setCurrentFlightInfo] = useState(null); // Store current flight info for retry
  const [currentRouteData, setCurrentRouteData] = useState(null); // Store current route data for delivery tracking
  const [showRouteInfoWindow, setShowRouteInfoWindow] = useState(true); // Control InfoWindow visibility
  const [selectedSegment, setSelectedSegment] = useState(null); // Track which flight segment is being viewed
  const [segmentTrackingData, setSegmentTrackingData] = useState(null); // Store individual segment tracking data
  const [checkoutLoading, setCheckoutLoading] = useState(false);
  const [clientSecret, setClientSecret] = useState("");
  const [checkoutSessionId, setCheckoutSessionId] = useState("");
  const [checkoutSessionUrl, setCheckoutSessionUrl] = useState("");
  const fileInputRef = useRef(null);
  const addModalRef = useRef(null);
  const documentsModalRef = useRef(null);
  const userData = JSON.parse(sessionStorage.getItem("userData"));
  console.log("userDara ==", userData)
  const user_id = userData?.user_id;
  const inputsRef = useRef([]);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [otpSource, setOtpSource] = useState("");
  console.log("pickupAddress:", pickupAddress);
  console.log("dropoffAddress:", dropoffAddress);
  const [flightData, setFlightData] = useState(null);
  const [isFlightLoading, setIsFlightLoading] = useState(false);
  const [centerLat, setCenterLat] = useState(0);
  const [centerLng, setCenterLng] = useState(0);
  const [path, setPath] = useState([]);

  const [pickupLat, setPickupLat] = useState(null);
  const [pickupLng, setPickupLng] = useState(null);
  const [dropLat, setDropLat] = useState(null);
  const [dropLng, setDropLng] = useState(null);
  const [currentStage, setCurrentStage] = useState([])
  const mapRef = useRef(null);
  const [activeChat, setActiveChat] = useState(null);
  const [showStops, setShowStops] = useState(false);
  const [trackIndex, setTrackIndex] = useState(0)
  const [sourceFlight, setSourceFlight] = useState([])
  const [destFlight, setDestFlight] = useState([])

  useEffect(() => {
    if (mapRef.current && currentStage?.origin_lat && currentStage?.origin_long) {
      mapRef.current.panTo({
        lat: Number(currentStage.origin_lat),
        lng: Number(currentStage.origin_long),
      });
    }
  }, [currentStage]);

  // 1️⃣ Get last stage
  const lastStage =
    currentStage?.stages?.[currentStage.stages.length - 1] || null;

  // 2️⃣ Extract driver location
  const providerLat = lastStage?.service_provider?.sp_lat
    ? Number(lastStage.service_provider.sp_lat)
    : null;

  const providerLng = lastStage?.service_provider?.sp_lng
    ? Number(lastStage.service_provider.sp_lng)
    : null;


  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: GOOGLE_MAP_KEY,
    libraries: ['places']
  });

  // Add this state to track if we have valid coordinates
  const [hasValidCoordinates, setHasValidCoordinates] = useState(false);
  useEffect(() => {
    if (booking?.quote?.quote_id) {
      sessionStorage.setItem("currentQuoteId", booking?.quote?.quote_id);
    }
  }, [booking]);

  // Check if flight has already landed - only show when status is 'Completed'
  const isFlightLanded = (stage) => {
    return stage?.status === 'Completed';
  };

  // 🟢 Fetch booking details
  const fetchBookingDetails = async () => {
    try {
      const res = await APIs.post("booking/getBookingById", {
        shipment_id: shipmentId,
      });

      const data = res?.data?.data;
      console.log("extra_charges?.total_extra_charges", data?.total_extra_charges)
      if (data) {
        setBooking(data);
        fetchSessionUrl(data.quote)
        // ✅ Set pickup/dropoff address from response
        setPickupAddress(data.pickup_address || {});
        setDropoffAddress(data.drop_address || {});
      } else {
        setBooking(null);
      }
    } catch (err) {
      console.error("Error fetching booking details", err);
      setBooking(null);
    } finally {
      setLoading(false);
    }
  };

  // 🟢 Fetch shipment tracking details
  const fetchShipmentTracking = async () => {
    try {
      setTrackingLoading(true);

      // Create FormData as specified in the API requirements
      const formData = new FormData();
      formData.append('shipment_id', shipmentId);

      const response = await APIs.post("booking/trackBooking", {
        shipment_id: shipmentId,
      });



      if (response.data.success) {
        const trackingResponseData = response.data.data;
        setTrackingData(trackingResponseData);
        setMainStatus(trackingResponseData.main_status);
        setStageStatus(trackingResponseData.stage_status || []);
        console.log("Tracking data fetched:", trackingResponseData);
      } else {
        console.error("Failed to fetch tracking data:", response.data.message);
        toast.error(response.data.message || "Failed to fetch tracking data");
      }
    } catch (error) {
      console.error("Error fetching shipment tracking:", error);
      toast.error("Error fetching tracking information");
    } finally {
      setTrackingLoading(false);
    }
  };
  // Fetch documents
  const fetchDocuments = async () => {
    try {
      const res = await APIs.post("booking/getDocumentsByShipmentId", {
        shipment_id: shipmentId,
        user_id: user_id
      });
      setDocuments(res.data.data || []);
    } catch (err) {
      console.error("Error fetching documents", err);
    }
  };

  useEffect(() => {
    fetchDocuments();
    fetchBookingDetails();
    fetchShipmentTracking();
  }, [shipmentId]);

  // Initialize Bootstrap collapse functionality
  useEffect(() => {
    if (stageStatus.length > 0) {
      // Ensure Bootstrap is available and initialize collapse components
      setTimeout(() => {
        if (window.bootstrap) {
          const collapseElements = document.querySelectorAll('[data-bs-toggle="collapse"]');
          collapseElements.forEach(element => {
            if (!element.hasAttribute('data-bs-initialized')) {
              element.setAttribute('data-bs-initialized', 'true');
            }
          });
        }
      }, 100);
    }
  }, [stageStatus]);

  // Initialize Bootstrap modal instances
  useEffect(() => {
    if (addModalRef.current) {
      addModalRef.current.instance = new window.bootstrap.Modal(addModalRef.current);
    }
    if (documentsModalRef.current) {
      documentsModalRef.current.instance = new window.bootstrap.Modal(documentsModalRef.current);
    }
  }, []);

  // Form validation
  const validateForm = () => {
    const newErrors = {};
    if (!docName.trim()) newErrors.docName = "Document title is required";
    if (!docDescription.trim()) newErrors.docDescription = "Description is required";
    if (!docFile) newErrors.docFile = "Please select a document file";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Add document
  const handleAddDocument = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const formData = new FormData();
    formData.append("shipment_id", shipmentId);
    formData.append("doc_name", docName);
    formData.append("doc_description", docDescription);
    formData.append("doc_file", docFile);
    formData.append("user_id", user_id);

    try {
      const res = await APIs.post("booking/addDocumentByShipmentId", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (res.data.success || res.data.message?.includes("successfully")) {
        // Reset form
        setDocName("");
        setDocDescription("");
        setDocFile(null);
        setErrors({});
        if (fileInputRef.current) fileInputRef.current.value = "";

        // Refresh documents
        await fetchDocuments();

        // ✅ Switch back to Documents Modal
        const addModalEl = document.getElementById("adddocumentModalToggle");
        const documentsModalEl = document.getElementById("documentModalToggle");

        const addModal = window.bootstrap.Modal.getInstance(addModalEl);
        if (addModal) addModal.hide();

        const documentsModal = window.bootstrap.Modal.getOrCreateInstance(documentsModalEl);
        documentsModal.show();

        // Show success toast
        toast.success("Document added successfully!", { position: "top-right" });
      } else {
        console.error("Failed to add document", res.data.message);
      }
    } catch (err) {
      console.error("Error adding document", err);
    }
  };

  const handleCloseModal = (modalId) => {
    const modalEl = document.getElementById(modalId);
    const modalInstance = window.bootstrap.Modal.getInstance(modalEl);

    if (modalInstance) {
      modalInstance.hide();
    }

    // Force cleanup of modal states and restore scrolling
    setTimeout(() => {
      // Use our reusable cleanup function
      cleanModalState();

      // Hide the modal element
      if (modalEl) {
        modalEl.style.display = 'none';
        modalEl.classList.remove('show');
      }
    }, 100);

    // Refresh documents if needed (without page reload)
    if (modalId === "documentModalToggle") {
      fetchDocuments();
    }
  };
  const handleDeleteDocument = async (docId) => {
    Swal.fire({
      text: "Do you want to delete this document?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    }).then((result) => {
      if (result.isConfirmed) {
        toast.success("Your file has been deleted.", { position: "top-right" });
      }
    });
    try {
      const res = await APIs.post("booking/updateDocumentStatus", {
        doc_id: docId,
        status: "Delete",
      });
      if (res?.success) {
        setDocuments((prevDocs) => prevDocs.filter((doc) => doc.doc_id !== docId));
        toast.success("Document deleted successfully", { position: "top-right" });
        window.location.reload();
      } else {
        console.error("Failed to delete document:", res?.message || "Unknown error");
      }
    } catch (error) {
      console.error("Error deleting document:", error);
    }
  };
  const isPdf = (filename) => {
    return filename?.toLowerCase().includes(".pdf");
  };

  // ---OTP Model functionality-----

  const handleOTPSubmit = async (e) => {
    e.preventDefault();

    const otpValue = otp.join("");
    if (otpValue.length !== 6) {
      toast.error("Enter 6-digit OTP", { position: "top-right" });
      return;
    }

    // ✅ Get pending user details (temporary user waiting for OTP)
    const pendingUser =
      JSON.parse(sessionStorage.getItem("pendingUser")) ||
      JSON.parse(sessionStorage.getItem("userData"));

    const email = pendingUser?.email;
    if (!email) {
      toast.error("User email not found. Please login again.", {
        position: "top-right",
      });
      return;
    }

    setLoading(true);


    try {
      const response = await APIs.post("user/verifyOTP", { otp: otpValue, email });

      if (response.data.status === "success") {
        toast.success("OTP verified successfully!", { position: "top-right" });

        // ✅ Save verified user data in session
        if (pendingUser) {
          // dispatch(setUserData(pendingUser));
          sessionStorage.setItem("userData", JSON.stringify(pendingUser));
          sessionStorage.removeItem("pendingUser"); // cleanup
        }

        // ✅ Close OTP modal and continue
        setTimeout(() => {
          const otpModalEl = document.getElementById("OtpModalToggle");
          const otpModal = window.bootstrap.Modal.getInstance(otpModalEl);
          otpModal.hide();

          if (otpSource === "forgot") {
            const resetModalEl = document.getElementById("ResetPasswordModalToggle");
            const resetModal = new window.bootstrap.Modal(resetModalEl);
            resetModal.show();
          } else {
            window.location.href = "/Dashboard";
          }
        }, 1000);
      } else {
        // ❌ OTP failed — clear session data
        toast.error(response.data.message || "OTP verification failed", {
          position: "top-right",
        });
        sessionStorage.removeItem("userData");
        sessionStorage.removeItem("pendingUser");
      }
    } catch (error) {
      // ❌ API error — clear session data
      toast.error(error.response?.data?.message || "OTP verification failed", {
        position: "top-right",
      });
      sessionStorage.removeItem("userData");
      sessionStorage.removeItem("pendingUser");
    } finally {
      setLoading(false);
    }
  };
  // OTP Handlers
  const handleChangeOTP = (e, idx) => {
    const val = e.target.value.replace(/[^0-9]/g, "");
    const newOtp = [...otp];
    newOtp[idx] = val ? val[0] : "";
    setOtp(newOtp);
    if (val && idx < 5) {
      inputsRef.current[idx + 1].focus();
    }
  };

  const handleBackspace = (e, idx) => {
    if (e.key === "Backspace" && !otp[idx] && idx > 0) {
      inputsRef.current[idx - 1].focus();
    }
  };


  // Update the center coordinates state
  useEffect(() => {
    const newCenterLat = pickupLat && dropLat ? (pickupLat + dropLat) / 2 : pickupLat || dropLat || currentLocation.lat
    const newCenterLng = pickupLng && dropLng ? (pickupLng + dropLng) / 2 : pickupLng || dropLng || currentLocation.lng;
    setCenterLat(newCenterLat);
    setCenterLng(newCenterLng);
    setHasValidCoordinates(!!(pickupLat && pickupLng) || !!(dropLat && dropLng));
  }, [pickupLat, pickupLng, dropLat, dropLng]);

  // Fix scrolling issues - ensure body can always scroll and clean up modal states
  useEffect(() => {
    // Function to restore scrolling
    const restoreScrolling = () => {
      // Remove modal-open class from body
      document.body.classList.remove('modal-open');

      // Remove any leftover modal backdrops
      const backdrops = document.querySelectorAll('.modal-backdrop');
      backdrops.forEach(backdrop => backdrop.remove());

      // Ensure body can scroll
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';

      // Remove any inline styles that might block scrolling
      document.documentElement.style.overflow = '';

      console.log('Scrolling restored and modal states cleaned up');
    };

    // Run immediately
    restoreScrolling();

    // Set up interval to periodically check and fix scrolling issues
    const scrollCheckInterval = setInterval(restoreScrolling, 2000);

    // Cleanup function
    return () => {
      clearInterval(scrollCheckInterval);
      restoreScrolling();
    };
  }, []); // Run once on mount and cleanup on unmount

  const pathCoords =
    pickupLat && pickupLng && dropLat && dropLng
      ? [
        { lat: pickupLat, lng: pickupLng },
        { lat: dropLat, lng: dropLng },
      ]
      : [];
  const [errorMessage, setErrorMessage] = useState("");


  const lastTrack =
    flightData?.tracks && flightData.tracks.length > 0
      ? flightData.tracks[flightData.tracks.length - 1]
      : null;

  // ---------- Flight States ----------


  // ---------- Flight Fetch ----------

  // ---------- Flight Tracking (Flightradar24) ----------

  // Generate demo flight data for demonstration when real data is not available
  // const generateDemoFlightData = (flightInfo, booking) => {
  //   try {
  //     const flightNo = flightInfo?.flight_no || booking?.quote?.flight_no || 'AA123';
  //     const airlineName = flightInfo?.airline_name || booking?.quote?.airline_name || 'American Airlines';

  //     // Generate realistic flight path for a live flight (example: New York to London - currently in transit)
  //     const now = new Date();
  //     const flightStartTime = new Date(now.getTime() - 4 * 60 * 60 * 1000); // Flight started 4 hours ago

  //     // Realistic flight path with the aircraft currently over the Atlantic
  //     const demoTracks = [
  //       // Takeoff from JFK
  //       { lat: 40.6413, lon: -73.7781, alt: 0, gspeed: 0, callsign: flightNo, timestamp: flightStartTime.getTime() },
  //       { lat: 40.6500, lon: -73.7000, alt: 2000, gspeed: 180, callsign: flightNo, timestamp: flightStartTime.getTime() + 600000 },
  //       { lat: 40.7000, lon: -72.5000, alt: 10000, gspeed: 250, callsign: flightNo, timestamp: flightStartTime.getTime() + 1200000 },

  //       // Climbing and heading over Atlantic
  //       { lat: 41.2033, lon: -70.1097, alt: 25000, gspeed: 450, callsign: flightNo, timestamp: flightStartTime.getTime() + 3600000 },
  //       { lat: 42.3601, lon: -65.4783, alt: 35000, gspeed: 520, callsign: flightNo, timestamp: flightStartTime.getTime() + 2 * 3600000 },

  //       // Currently over mid-Atlantic (this is where the plane is "now")
  //       { lat: 45.5017, lon: -55.2483, alt: 37000, gspeed: 530, callsign: flightNo, timestamp: flightStartTime.getTime() + 3 * 3600000 },

  //       // Future path (not yet traveled - for demonstration of route)
  //       { lat: 48.8566, lon: -35.1234, alt: 37000, gspeed: 525, callsign: flightNo, timestamp: flightStartTime.getTime() + 4 * 3600000 },
  //       { lat: 50.9419, lon: -15.2483, alt: 25000, gspeed: 400, callsign: flightNo, timestamp: flightStartTime.getTime() + 5 * 3600000 },
  //       { lat: 51.4700, lon: -0.4543, alt: 5000, gspeed: 180, callsign: flightNo, timestamp: flightStartTime.getTime() + 6 * 3600000 }
  //     ];

  //     // Current position is the middle of the flight path (over Atlantic)
  //     const currentTrackIndex = 5; // Currently over mid-Atlantic
  //     const currentTrack = demoTracks[currentTrackIndex];

  //     // Show only the path that has been traveled so far
  //     const traveledTracks = demoTracks.slice(0, currentTrackIndex + 1);
  //     const pathCoords = traveledTracks.map(track => ({
  //       lat: parseFloat(track.lat),
  //       lng: parseFloat(track.lon)
  //     }));

  //     const demoData = {
  //       // Summary data
  //       fr24_id: 'demo_live_flight_456',
  //       flight_number: flightNo,
  //       airline_name: airlineName,
  //       aircraft_type: 'Boeing 777-300ER',
  //       origin_airport: flightInfo?.origin || 'JFK (New York)',
  //       destination_airport: flightInfo?.destination || 'LHR (London Heathrow)',
  //       departure_time: flightStartTime.toISOString(),
  //       estimated_arrival: new Date(now.getTime() + 2 * 60 * 60 * 1000).toISOString(), // 2 hours from now

  //       // Track data (current position)
  //       tracks: traveledTracks,
  //       path: pathCoords,
  //       lastTrack: {
  //         lat: parseFloat(currentTrack.lat),
  //         lon: parseFloat(currentTrack.lon),
  //         alt: currentTrack.alt,
  //         gspeed: currentTrack.gspeed,
  //         callsign: currentTrack.callsign,
  //       },

  //       // Flight status
  //       status: 'In Flight',
  //       progress: '60%', // 60% of journey completed
  //       remaining_time: '2h 15m',

  //       // Demo flag
  //       isDemo: true,
  //       demoNote: 'Live flight simulation - Currently over Atlantic Ocean'
  //     };

  //     return demoData;
  //   } catch (error) {
  //     console.error('Error generating demo flight data:', error);
  //     return null;
  //   }
  // };

  // 🔹 This function is called when the Track button is clicked
  // 🔹 This function is called when the Track button is clicked
  const handleTrackFlight = async (flightInfo = null, index = 0) => {
    try {
      setIsFlightLoading(true);
      setErrorMessage(null);
      setFlightData(null);
      setHasValidCoordinates(false);

      // Store flight info for retry functionality
      setCurrentFlightInfo(flightInfo);

      // Check if we have flight_segment data from the stage
      if (flightInfo?.flight_segment) {
        try {
          const flightSegments = JSON.parse(flightInfo.flight_segment);
          console.log('🛩️ Flight Segments Data:', flightSegments);

          // Process multiple flight segments
          const processedFlights = flightSegments.map((segment, index) => {
            const flightNumber = `${segment.carrierCode}${segment.number}`;

            return {
              segment_index: index + 1,
              flight_number: flightNumber,
              carrier_code: segment.carrierCode,
              aircraft_type: segment.aircraft?.code,
              departure: {
                airport: segment.departure.iataCode,
                terminal: segment.departure.terminal,
                at_utc: segment.departure?.at_utc,
                time: segment.departure.at
              },
              arrival: {
                airport: segment.arrival.iataCode,
                at_utc: segment.arrival?.at_utc,
                time: segment.departure.at
              },
              duration: segment.duration,
              stops: segment.numberOfStops,
              operating_carrier: segment.operating?.carrierName || segment.operating?.carrierCode
            };
          });

          // Create comprehensive flight data
          const multiFlightData = {
            segments: processedFlights,
            total_segments: processedFlights.length,
            origin_airport: `${processedFlights[0].departure.airport} (${flightInfo?.origin || 'Origin'})`,
            destination_airport: `${processedFlights[processedFlights.length - 1].arrival.airport} (${flightInfo?.destination || 'Destination'})`,
            departure_time: processedFlights[0].departure.time,
            arrival_time: processedFlights[processedFlights.length - 1].arrival.time,
            status: 'Multi-Segment Flight',
            isMultiSegment: true,
            stage_data: flightInfo
          };

          setFlightData(multiFlightData);
          setErrorMessage(null);
          setIsFlightLoading(false);
          handleTrackFlightSegment(multiFlightData?.segments[index], index)

          // Show modal
          const modal = new window.bootstrap.Modal(document.getElementById("TrackModalToggle"));
          modal.show();

          return;
        } catch (parseError) {
          console.error('Error parsing flight_segment:', parseError);
          // Fall back to original flight tracking if parsing fails
        }
      }

      // Original flight tracking logic for single flights (fallback)
      const callsign = flightInfo?.flight_no || booking?.quote?.flight_no || "23232";

      // Use stage dates if available, otherwise use booking pickup date or fallback dates
      let dateFrom, dateTo;
      if (flightInfo?.pick_up_date) {
        const pickupDate = new Date(flightInfo.pick_up_date);
        dateFrom = new Date(pickupDate.getTime() - 24 * 60 * 60 * 1000).toISOString(); // 1 day before pickup
        dateTo = new Date(pickupDate.getTime() + 24 * 60 * 60 * 1000).toISOString(); // 1 day after pickup
      } else if (booking?.pickup_date) {
        const pickupDate = new Date(booking.pickup_date);
        dateFrom = new Date(pickupDate.getTime() - 24 * 60 * 60 * 1000).toISOString();
        dateTo = new Date(pickupDate.getTime() + 24 * 60 * 60 * 1000).toISOString();
      } else {
        dateFrom = "2025-11-01T00:01:14Z";
        dateTo = "2027-11-01T23:23:59Z";
      }

      console.log('🛩️ Single Flight Tracking Data:', {
        callsign,
        dateFrom,
        dateTo,
        flightInfo,
        bookingQuote: booking?.quote
      });

      const summaryRes = await APIs.get(
        `flightradar/summary?flight_datetime_from=${encodeURIComponent(
          dateFrom
        )}&flight_datetime_to=${encodeURIComponent(dateTo)}&callsigns=${callsign}`
      );

      if (!summaryRes.data?.success || !summaryRes.data?.data?.data?.length)
        throw new Error("No flight summary found for this callsign/date range.");

      const summaryData = summaryRes.data.data.data[0];
      const flightId = summaryData.fr24_id;

      const trackRes = await APIs.get(
        `flightradar/tracks?flight_id=${flightId}`
      );

      if (
        !trackRes.data?.success ||
        !Array.isArray(trackRes.data?.data) ||
        !trackRes.data?.data[0]?.tracks?.length
      ) {
        throw new Error("No flight track data available for this flight.");
      }

      const tracks = trackRes.data.data[0].tracks;
      const pathCoords = tracks.map((t) => ({
        lat: parseFloat(t.lat),
        lng: parseFloat(t.lon),
      }));

      const lastTrack = tracks[tracks.length - 1];

      // Safely set pickup/drop/path from pathCoords
      if (Array.isArray(pathCoords) && pathCoords.length > 0) {
        const first = pathCoords[0];
        const last = pathCoords[pathCoords.length - 1];

        if (first?.lat && first?.lng && last?.lat && last?.lng) {
          setPickupLat(first.lat);
          setPickupLng(first.lng);
          setDropLat(last.lat);
          setDropLng(last.lng);
          setPath([first, last]);

          // Center between pickup and drop
          setCenterLat((first.lat + last.lat) / 2);
          setCenterLng((first.lng + last.lng) / 2);
          setHasValidCoordinates(true);
        } else {
          setHasValidCoordinates(false);
        }
      } else {
        setHasValidCoordinates(false);
      }

      const mappedData = {
        ...summaryData,
        tracks,
        path: pathCoords,
        lastTrack: {
          lat: parseFloat(lastTrack.lat),
          lon: parseFloat(lastTrack.lon),
          alt: lastTrack.alt,
          gspeed: lastTrack.gspeed,
          callsign: lastTrack.callsign,
          track: lastTrack.track
        },
      };

      setFlightData(mappedData);
      setErrorMessage(null);

      if (lastTrack.lat && lastTrack.lon) {
        const lat = parseFloat(lastTrack.lat);
        const lng = parseFloat(lastTrack.lon);
        setCenterLat(lat);
        setCenterLng(lng);
        setHasValidCoordinates(true);
      }

      setIsFlightLoading(false);

      // Show modal and fix map resize
      const modal = new window.bootstrap.Modal(document.getElementById("TrackModalToggle"));
      modal.show();

      setTimeout(() => {
        if (window.google?.maps) window.google.maps.event.trigger(window, "resize");
      }, 500);
    } catch (error) {
      console.error("Error fetching flight data:", error);
      const flightDisplay = flightInfo?.flight_no || booking?.quote?.flight_no || "Unknown Flight";

      console.log(`🛩️ Real flight data not available for ${flightDisplay}, using demo data for demonstration`);

      // Generate demo flight data for demonstration
      let msg = error.response
        ? `API error for flight ${flightDisplay}: ${error.response.status} - ${error.response.data?.message || "Unknown error"}`
        : error.request
          ? `No response received from server for flight ${flightDisplay} (check CORS or network).`
          : `Error tracking flight ${flightDisplay}: ${error.message}`;

      setErrorMessage(msg);
      setFlightData(null);

      // const demoFlightData = generateDemoFlightData(flightInfo, booking);

      //   if (demoFlightData) {
      //     // setFlightData(demoFlightData);
      //     // setErrorMessage(null);
      //     // setHasValidCoordinates(true);

      //     // // Set demo coordinates
      //     // setCenterLat(demoFlightData.lastTrack.lat);
      //     // setCenterLng(demoFlightData.lastTrack.lon);

      //   } else {
      //     // If demo data generation fails, show error
      //     let msg = error.response
      //       ? `API error for flight ${flightDisplay}: ${error.response.status} - ${error.response.data?.message || "Unknown error"}`
      //       : error.request
      //         ? `No response received from server for flight ${flightDisplay} (check CORS or network).`
      //         : `Error tracking flight ${flightDisplay}: ${error.message}`;

      //     setErrorMessage(msg);
      //     setFlightData(null);
      //   }
      toast.error("Flight could not be track right now.", { position: "top-right" });


      // setIsFlightLoading(false);
      // const modal = new window.bootstrap.Modal(document.getElementById("TrackModalToggle"));
      // modal.show();
    }
  };

  // Track individual flight segment
  const handleTrackFlightSegment = async (segment, segmentIndex) => {
    try {
      setIsFlightLoading(true);
      setSelectedSegment(segmentIndex);
      setSegmentTrackingData(null);

      console.log(`🛩️ Tracking individual segment ${segmentIndex + 1}:`, segment);

      // const callsign = 'JST043' //segment.flight_number;
      const departureDate = new Date(segment.departure.time);

      // Create date range for the specific flight
      const dateFrom = new Date(departureDate.getTime() - 12 * 60 * 60 * 1000).toISOString(); // 12 hours before
      const dateTo = new Date(departureDate.getTime() + 24 * 60 * 60 * 1000).toISOString(); // 24 hours after

      // const dateFrom = segment.departure.time // 12 hours before
      // const dateTo =  segment.arrival.time  // 24 hours after
      const payload = qs.stringify({
        flight_datetime_from: dateFrom, // "BOM"
        flight_datetime_to: dateTo, // "BOM"
        flights: segment.flight_number, // "BOM"
      });

      const summaryRes1 = await APIs.post(
        "flightradar/summaryFlightNo",
        payload,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      if (!summaryRes1.data?.success || !summaryRes1.data?.data?.data?.length) {
        throw new Error(`No flight data found`);
      }

      console.log("summaryRes1", summaryRes1.data.data.data[summaryRes1.data.data.data.length - 1].callsign)
      const summaryData = summaryRes1.data.data.data[summaryRes1.data.data.data.length - 1];

      const callsign = summaryRes1.data.data.data[summaryRes1.data.data.data.length - 1].callsign;

      console.log('🛩️ Segment Flight Tracking Data:', {
        callsign,
        dateFrom,
        dateTo,
        departureTime: segment.departure.time,
        segment
      });

      // const summaryRes = await APIs.get(
      //   `flightradar/summary?flight_datetime_from=${encodeURIComponent(
      //     dateFrom
      //   )}&flight_datetime_to=${encodeURIComponent(dateTo)}&callsigns=${callsign}`
      // );

      // if (!summaryRes.data?.success || !summaryRes.data?.data?.data?.length) {
      //   throw new Error(`No flight data found for ${callsign}`);
      // }

      // const summaryData = summaryRes.data.data.data[summaryRes.data.data.data.length -1];
      const flightId = summaryData.fr24_id;

      const trackRes = await APIs.get(
        `flightradar/tracks?flight_id=${flightId}`
      );

      if (
        !trackRes.data?.success ||
        !Array.isArray(trackRes.data?.data) ||
        !trackRes.data?.data[0]?.tracks?.length
      ) {
        throw new Error(`No tracking data available for ${callsign}`);
      }

      const tracks = trackRes.data.data[0].tracks;
      const pathCoords = tracks.map((t) => ({
        lat: parseFloat(t.lat),
        lng: parseFloat(t.lon),
      }));

      const lastTrack = tracks[tracks.length - 1];

      const segmentData = {
        ...summaryData,
        tracks,
        path: pathCoords,
        lastTrack: {
          lat: parseFloat(lastTrack.lat),
          lon: parseFloat(lastTrack.lon),
          alt: lastTrack.alt,
          gspeed: lastTrack.gspeed,
          callsign: lastTrack.callsign,
          track: lastTrack.track
        },
        segmentInfo: segment,
        isSegmentTracking: true
      };

      setSegmentTrackingData(segmentData);

      // Update map center to current flight position
      if (lastTrack.lat && lastTrack.lon) {
        setCenterLat(parseFloat(lastTrack.lat));
        setCenterLng(parseFloat(lastTrack.lon));
        setHasValidCoordinates(true);
      }

      setIsFlightLoading(false);

    } catch (error) {
      console.error(`Error tracking segment ${segmentIndex + 1}:`, error);

      // Generate demo data for the specific segment
      // const demoSegmentData = generateSegmentDemoData(segment, segmentIndex);
      // if (demoSegmentData) {
      //   setSegmentTrackingData(demoSegmentData);
      //   setCenterLat(demoSegmentData.lastTrack.lat);
      //   setCenterLng(demoSegmentData.lastTrack.lon);
      //   setHasValidCoordinates(true);
      // }
      toast.error("Flight could not be track right now.", { position: "top-right" });

      setIsFlightLoading(false);
    }
  };

  console.log("flightData", flightData)

  // Generate demo data for individual flight segments
  // const generateSegmentDemoData = (segment, segmentIndex) => {
  //   try {
  //     const now = new Date();
  //     const departureTime = new Date(segment.departure.time);
  //     const arrivalTime = new Date(segment.arrival.time);

  //     // Calculate if flight should be in progress
  //     const isInProgress = now >= departureTime && now <= arrivalTime;
  //     const totalDuration = arrivalTime.getTime() - departureTime.getTime();
  //     const elapsed = Math.max(0, now.getTime() - departureTime.getTime());
  //     const progress = Math.min(1, elapsed / totalDuration);

  //     // Get approximate coordinates for airports (simplified for demo)
  //     const airportCoords = {
  //       'LAX': { lat: 33.9425, lng: -118.4081 },
  //       'SEA': { lat: 47.4502, lng: -122.3088 },
  //       'AMS': { lat: 52.3105, lng: 4.7683 },
  //       'LBA': { lat: 53.8658, lng: -1.6605 },
  //       'JFK': { lat: 40.6413, lng: -73.7781 },
  //       'LHR': { lat: 51.4700, lng: -0.4543 }
  //     };

  //     const origin = airportCoords[segment.departure.airport] || { lat: 40, lng: -73 };
  //     const destination = airportCoords[segment.arrival.airport] || { lat: 51, lng: 0 };

  //     // Calculate current position based on progress
  //     const currentLat = origin.lat + (destination.lat - origin.lat) * progress;
  //     const currentLng = origin.lng + (destination.lng - origin.lng) * progress;
  //     const altitude = isInProgress ? 35000 + Math.random() * 5000 : 0;
  //     const groundSpeed = isInProgress ? 450 + Math.random() * 100 : 0;

  //     return {
  //       flight_number: segment.flight_number,
  //       aircraft_type: segment.aircraft_type || 'Unknown',
  //       origin_airport: segment.departure.airport,
  //       destination_airport: segment.arrival.airport,
  //       departure_time: segment.departure.time,
  //       arrival_time: segment.arrival.time,
  //       status: isInProgress ? 'In Flight' : (now > arrivalTime ? 'Landed' : 'Scheduled'),
  //       progress: `${Math.round(progress * 100)}%`,
  //       lastTrack: {
  //         lat: currentLat,
  //         lon: currentLng,
  //         alt: Math.round(altitude),
  //         gspeed: Math.round(groundSpeed),
  //         callsign: segment.flight_number,
  //       },
  //       path: [origin, { lat: currentLat, lng: currentLng }],
  //       tracks: [
  //         { lat: origin.lat, lon: origin.lng, alt: 0, gspeed: 0, callsign: segment.flight_number },
  //         { lat: currentLat, lon: currentLng, alt: altitude, gspeed: groundSpeed, callsign: segment.flight_number }
  //       ],
  //       segmentInfo: segment,
  //       isSegmentTracking: true,
  //       isDemo: true,
  //       demoNote: `${segment.flight_number} - ${isInProgress ? 'Currently in flight' : (now > arrivalTime ? 'Flight completed' : 'Scheduled flight')}`
  //     };
  //   } catch (error) {
  //     console.error('Error generating segment demo data:', error);
  //     return null;
  //   }
  // };

  // Generate curved arc path between two points for more realistic flight paths
  const generateArcPath = (start, end) => {
    const path = [];
    const steps = 20; // Number of points in the arc

    for (let i = 0; i <= steps; i++) {
      const fraction = i / steps;

      // Linear interpolation for basic path
      const lat = start.lat + (end.lat - start.lat) * fraction;
      const lng = start.lng + (end.lng - start.lng) * fraction;

      // Add curvature for more realistic flight path
      const curvature = Math.sin(fraction * Math.PI) * 2; // Peak at middle
      const curvedLat = lat + curvature;

      path.push({ lat: curvedLat, lng });
    }

    return path;
  };

  // Get destination coordinates based on airport code
  // const getDestinationCoordinates = (airportCode) => {
  //   const airportCoords = {
  //     'LAX': { lat: 33.9425, lng: -118.4081 },
  //     'SEA': { lat: 47.4502, lng: -122.3088 },
  //     'AMS': { lat: 52.3105, lng: 4.7683 },
  //     'LBA': { lat: 53.8658, lng: -1.6605 },
  //     'JFK': { lat: 40.6413, lng: -73.7781 },
  //     'LHR': { lat: 51.4700, lng: -0.4543 }
  //   };

  //   return airportCoords[airportCode] || { lat: 0, lng: 0 };
  // };


  // Helper function to get status description
  const getStatusDescription = (status) => {
    const statusMap = {
      'Assigned': 'Status update received',
      'Accepted': 'Shipment has been accepted by service provider',
      'Pickup': 'Shipment picked up from sender location',
      'InTransit': 'Shipment is currently in transit',
      'AtOrigin': 'Shipment has arrived at origin airport/terminal',
      'Boarded': 'Shipment loaded onto aircraft',
      'AtDestination': 'Shipment has arrived at destination airport/terminal',
      'Customs': 'Shipment is going through customs clearance',
      'Completed': 'Shipment delivery completed',
      'Booked': 'Shipment booking has been confirmed',
      'ArrivedAtOriginAirport': 'Shipment has arrived at origin airport',
      'ArrivedAtDestinationAirport': 'Shipment has arrived at destination airport',
      'OutForDelivery': 'Shipment is out for final delivery',
      'Delivered': 'Shipment successfully delivered to recipient'
    };
    return statusMap[status] || 'Status update received';
  };

  // Clean modal state and restore page scrolling
  const cleanModalState = () => {
    // Remove any bootstrap modal backdrops
    const backdrops = document.querySelectorAll('.modal-backdrop');
    backdrops.forEach(backdrop => backdrop.remove());

    // Remove modal-open class from body
    document.body.classList.remove('modal-open');

    // Reset body styles
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';

    // Force scroll position update
    document.documentElement.style.overflow = '';
    window.scrollTo(window.scrollX, window.scrollY);
  };

  // Handle delivery person tracking
  // Geocode address to get coordinates
  const geocodeAddress = async (address) => {
    try {
      const response = await fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(address)}.json?access_token=YOUR_MAPBOX_TOKEN`);

      // Fallback to Google Geocoding if available
      if (window.google && window.google.maps && window.google.maps.Geocoder) {
        const geocoder = new window.google.maps.Geocoder();
        return new Promise((resolve, reject) => {
          geocoder.geocode({ address }, (results, status) => {
            if (status === 'OK' && results[0]) {
              const location = results[0].geometry.location;
              resolve({
                lat: location.lat(),
                lng: location.lng()
              });
            } else {
              // If geocoding fails, use default coordinates for demonstration
              console.log(`Geocoding failed for ${address}, using default coordinates`);
              resolve(null);
            }
          });
        });
      }

      // If no geocoding service available, return null
      return null;
    } catch (error) {
      console.error('Geocoding error:', error);
      return null;
    }
  };

  // Get demo coordinates based on address (for demo purposes)
  const getDemoCoordinates = (address) => {
    // Simple demo coordinates based on common locations
    if (address.toLowerCase().includes('los angeles') || address.toLowerCase().includes('la ')) {
      return { lat: 34.0522, lng: -118.2437 }; // Los Angeles
    }
    if (address.toLowerCase().includes('lax') || address.toLowerCase().includes('airport')) {
      return { lat: 33.9425, lng: -118.4081 }; // LAX Airport
    }
    if (address.toLowerCase().includes('new york') || address.toLowerCase().includes('ny')) {
      return { lat: 40.7128, lng: -74.0060 }; // New York
    }
    if (address.toLowerCase().includes('chicago')) {
      return { lat: 41.8781, lng: -87.6298 }; // Chicago
    }
    // Default to LA downtown for demo
    return { lat: 34.0522, lng: -118.2437 };
  };

  const handleTrackDeliveryPerson = async (serviceProvider, stageData = null) => {
    console.log('Tracking delivery person:', serviceProvider);
    console.log('Stage data for route:', stageData);

    if (stageData) {
      console.log('Route details:', {
        origin: stageData.origin,
        destination: stageData.destination,
        distance: stageData.total_distance,
        pickupDate: stageData.pick_up_date,
        dropDate: stageData.drop_date
      });

      // Get coordinates for origin and destination
      const originCoords = getDemoCoordinates(stageData.origin);
      const destinationCoords = getDemoCoordinates(stageData.destination);

      // Store the stage route information for use in the delivery tracking modal
      setCurrentRouteData({
        origin: stageData.origin,
        destination: stageData.destination,
        originCoords: originCoords,
        destinationCoords: destinationCoords,
        distance: stageData.total_distance,
        pickupDate: stageData.pick_up_date,
        dropDate: stageData.drop_date,
        serviceProvider: serviceProvider
      });

      // Update pickup and dropoff addresses for the modal
      setPickupAddress({
        address: stageData.origin,
        latitude: originCoords.lat,
        longitude: originCoords.lng
      });

      setDropoffAddress({
        address: stageData.destination,
        latitude: destinationCoords.lat,
        longitude: destinationCoords.lng
      });
    }

    // Show the delivery tracking modal
    console.log('Opening delivery tracking modal with route data');
  };

  // Helper function to determine step status
  const getStepStatus = (index, totalSteps, currentMainStatus) => {
    // Simple logic: if we have tracking data, show progress based on stage completion
    if (!stageStatus.length) return 'upcoming';

    const allStages = stageStatus.reduce((acc, stageGroup) => {
      return acc.concat(stageGroup.stages || []);
    }, []);

    if (allStages.length === 0) return 'upcoming';

    // Determine step status based on index and available tracking data
    const progressPercentage = (allStages.length / totalSteps) * 100;
    const stepThreshold = ((index + 1) / totalSteps) * 100;

    if (stepThreshold <= progressPercentage) {
      return 'completed';
    } else if (index === Math.floor(allStages.length / totalSteps * totalSteps)) {
      return 'active';
    } else {
      return 'upcoming';
    }
  };

  // Toggle stage expansion
  const toggleStageExpansion = (stageIndex) => {
    setExpandedStages(prev => ({
      ...prev,
      [stageIndex]: !prev[stageIndex]
    }));
  };
  // // if (loading) return <div>Loading tracking data...</div>;
  // // if (!trackingData) return <div>No tracking details found</div>;

  // // Extract stage data from response
  // const stages = trackingData.stage_status?.[0]?.stages || [];
  // const lastStage = stages[stages.length - 1]?.status;

  // // Find which step should be active based on lastStage
  // const currentStepIndex = stepLabels.findIndex(
  //   (label) => label.toLowerCase().includes(lastStage?.toLowerCase())
  // );
  // const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");
  const userId = userData?.user_id;
  const handlePayNow = async () => {
    if (!booking.quote) {
      alert("Quote not loaded");
      return;
    }

    setCheckoutLoading(true);
    try {
      // 1️⃣ Create Stripe payment session only now (not earlier)
      const sessionData = await fetchSessionUrl(booking.quote);

      if (!sessionData) {
        throw new Error("Unable to create payment session. Please try again.");
      }

      // 2️⃣ Save transaction details (only during Pay Now flow)
      try {
        await APIs.post("payment/getPaymentDetailsByUserId", {
          user_id: userId,
          shipment_id: shipmentId,
          amount: booking?.quote?.total_pay_amount,
          currency: "USD",
          quote_id: booking?.quote?.quote_id,
          stripe_pay_id: sessionData?.stripe_pay_id || sessionData?.id || "",
        });
        console.log("Payment details saved successfully before redirect.");
      } catch (err) {
        console.error("Error saving payment details before redirect:", err);
        // optional: toast.warn("Payment details not saved, but continuing...");
      }

      // 3️⃣ Redirect user to Stripe checkout page
      if (sessionData.url) {
        window.location.href = sessionData.url;
      } else {
        throw new Error("Payment session URL not available.");
      }
    } catch (error) {
      console.error("Payment error:", error);
      alert(error.message || "Payment failed");
    } finally {
      setCheckoutLoading(false);
    }
  };

  const fetchSessionUrl = async (quoteData) => {
    try {
      const res = await APIs.post("payment/getSessionIdForPayment", {
        amount: quoteData.total_pay_amount,
        currency: "USD",
        quote_id: quoteData.quote_id, // optional for backend linking
      });

      const sessionData = res.data.data;

      if (sessionData?.url) {
        setCheckoutSessionUrl(sessionData.url);
        setCheckoutSessionId(sessionData.id);
        console.log("Stripe session ID:", sessionData.id);
      }

      if (sessionData?.client_secret) {
        setClientSecret(sessionData.client_secret);
        if (sessionData.stripe_pay_id) {
          sessionStorage.setItem("stripePayId", sessionData.stripe_pay_id);
        }
        console.log("Stripe Pay ID:", sessionData.stripe_pay_id);
      }

      return sessionData;
    } catch (err) {
      console.error("Error fetching Stripe session URL:", err);
      return null;
    }
  };

  const now = new Date();

  const getShowTrackBtn = (seg) => {
    const departureTime = parseFlightRadarTime(seg?.departure);
    const arrivalTime = parseFlightRadarTime(seg?.arrival);

    if (!departureTime || !arrivalTime) return false;

    const now = Date.now();

    return (
      now >= departureTime.getTime() - 15 * 60 * 1000 &&
      now <= arrivalTime.getTime()
    );
  };


  const getSourceLatLng = async (iata) => {
    try {
      const payload = qs.stringify({
        iata: iata, // "BOM"
      });

      const response = await APIs.post(
        "flightradar/getAirportLatLong",
        payload,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      if (response.data.success) {
        // Store response in state
        setSourceFlight(response.data);
      }
    } catch (err) {
      console.error("getSourceLatLng error", err);
    } finally {
      console.log("getSourceLatLng error");
    }
  };

  const getDestLatLng = async (iata) => {
    try {
      const payload = qs.stringify({
        iata: iata, // "BOM"
      });

      const response = await APIs.post(
        "flightradar/getAirportLatLong",
        payload,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      if (response.data.success) {
        // Store response in state
        setDestFlight(response.data);
      }
    } catch (err) {
      console.error("getDestLatLng error", err);
    } finally {
      console.log("getDestLatLng error");
    }
  };
  console.log("trackIndex", trackIndex)


  // Safely parse FlightRadar time (prefers UTC)
  const parseFlightRadarTime = (segTime) => {
    if (!segTime) return null;

    // If at_utc exists → always use it
    if (segTime?.at_utc) {
      return new Date(segTime?.at_utc.replace(" ", "T") + "Z");
    }

    // Fallback: if only at exists (local airport time – unsafe)
    // Treat as local ONLY as last resort
    if (segTime?.at) {
      return new Date(segTime?.at);
    }

    return null;
  };

  const getUserTzShort = () => {
    const parts = new Intl.DateTimeFormat("en", {
      timeZoneName: "short"
    }).formatToParts(new Date());

    return parts.find(p => p.type === "timeZoneName")?.value;
  };
  return (
    <div className="page-content">
      <section className="step-section-md">
        <div className="container">
          <div className="row">
            {/* Sidebar */}
            <div className="col-lg-3">
              <Sidebar />
            </div>

            {/* Main Content */}

            <div className="col-lg-9">
              <a
                className="btn btn-primary d-inline-block mb-4 d-lg-none"
                data-bs-toggle="offcanvas"
                href="#offcanvasExample"
                role="button"
              >
                Show Menu
              </a>

              <div className="row">
                {/* Left Card */}
                <div className="col-xl-6 col-lg-12 col-md-6">
                  <div className="card shadow-sm">
                    <div className="card-body">
                      {/* Header */}
                      <div className="d-flex align-items-start align-items-xl-center justify-content-between flex-column flex-xl-row gap-3">
                        <div className="d-flex d-xl-block justify-content-between w-100">
                          <h3 className="commen-h3-title mb-0">{booking?.shipment_no || 123456}</h3>
                          <small className="mb-0">
                            <i className="eagle-base-icon-calendar-1"></i>{booking?.created_at &&
                              new Date(booking.created_at).toLocaleDateString('en-GB').replace(/\//g, '-')
                            }

                          </small>
                        </div>
                        <div className="icon-wrapper">
                          {/* <a href="#">
                            <i className="ti-printer"></i>
                          </a> */}
                          {/* <a href="#">
                                <i className="eagle-base-icon-share-2"></i>
                            </a> */}
                          <a
                            className="btn btn-success"
                            data-bs-toggle="modal"
                            data-bs-dismiss="modal"
                            href="#documentModalToggle"
                            ref={documentsModalRef}
                          >
                            <i className="eagle-base-icon-doc-file-format"></i> Documents
                          </a>
                        </div>
                      </div>

                      <hr />

                      {/* Description */}
                      <div className="mb-0">
                        <h3 className="commen-h3-title mb-0">Important Documents</h3>
                        <p>
                          Rely on us for the swift and secure transport of sensitive,
                          time-critical documents, ensuring confidentiality and timely
                          arrival every time.
                        </p>
                      </div>

                      <hr />

                      {/* OLD HARDCODED STEPPER - KEEP FOR COMPARISON */}
                      {/* 
                        <div id="vertical-stepper" className="stepper">
                            
                            {/* Step 1 *\/}
                            <div className="step completed" data-index="0">
                            <div className="bullet" aria-hidden="true">
                                <i className="ti-check"></i>
                            </div>
                            <div className="content">
                                <div>
                                <div className="fw-bold">Booking Confirmed</div>
                                <div className="small text-muted">
                                    Shipment booking successfully created.
                                </div>
                                <div className="time">8/12/2025, 7:27:44 PM</div>
                                </div>
                            </div>
                            </div>

                            {/* Step 2 *\/}
                            <div className="step completed" data-index="1">
                            <div className="bullet" aria-hidden="true">
                                <i className="ti-check"></i>
                            </div>
                            <div className="content">
                                <div>
                                <div className="fw-bold">Picked Up</div>
                                <div className="small text-muted">
                                    Shipment collected from sender.
                                </div>
                                <div className="time">8/12/2025, 7:27:44 PM</div>
                                </div>
                            </div>
                            </div>

                            {/* Step 3 *\/}
                            <div className="step active" data-index="2">
                            <div className="bullet">3</div>
                            <div className="content">
                                <div>
                                <div className="fw-bold">Carrier Assigned</div>
                                <div className="small text-muted">
                                    Courier partner allocated for transport.
                                </div>
                                <div className="time">8/12/2025, 7:27:44 PM</div>

                                <div className="carrier-detais-wrapper">
                                    <div className="carrier-detais">
                                    <h5 className="mb-0">
                                        <i className="eagle-base-icon-user mr-3"></i> Marcel Henry
                                    </h5>
                                    <small className="mb-0">ID #123456</small>
                                    </div>
                                    <div className="carrier-contact">
                                    <a className="btn btn-success me-2" href="">
                                        <i className="eagle-base-icon-telephone"></i>
                                    </a>
                                    <a className="btn btn-success" href="">
                                        <i className="eagle-base-icon-chat-1"></i>
                                    </a>
                                    </div>
                                </div>
                                </div>
                            </div>
                            </div>

                            {/* Step 4 *\/}
                            <div className="step upcoming" data-index="3">
                            <div className="bullet">4</div>
                            <div className="content">
                                <div>
                                <div className="fw-bold">Arrived at Origin Airport</div>
                                <div className="small text-muted">
                                    Shipment reached the departure airport facility.
                                </div>
                                </div>
                            </div>
                            </div>

                            {/* Step 5 *\/}
                            <div className="step upcoming" data-index="4">
                            <div className="bullet">5</div>
                            <div className="content">
                                <div>
                                <div className="fw-bold">Boarded on Flight</div>
                                <div className="small text-muted">Shipment loaded onto aircraft.</div>
                                </div>
                            </div>
                            </div>

                            {/* Step 6 *\/}
                            <div className="step upcoming" data-index="5">
                            <div className="bullet">6</div>
                            <div className="content">
                                <div>
                                <div className="fw-bold">In Transit (Flight)</div>
                                <div className="small text-muted">Shipment currently in air transit.</div>

                                <div className="fligh-detail-wrapper">
                                    <hr />
                                    <h5 className="mb-0">Flight Details</h5>
                                    <div className="fligh-detail-1 d-flex justify-content-between align-items-center">
                                    <div className="d-flex gap-2">
                                        <img
                                        src="/images/UnitedAirlines.svg"
                                        alt="United Airlines"
                                        className="img-fluid"
                                        style={{ maxWidth: "50px" }}
                                        />
                                        <div>
                                        <h5 className="mb-0">United Airlines</h5>
                                        <p className="mb-0">UA 2608</p>
                                        </div>
                                    </div>
                                    <div className="carrier-contact">
                                        <a
                                        className="btn btn-success"
                                        data-bs-toggle="modal"
                                        href="#TrackModalToggle"
                                         onClick={() => {
                                          // Close any open modals first
                                          const existingModal = document.getElementById('TrackModalToggle');
                                          if (existingModal) {
                                            const modal = window.bootstrap.Modal.getInstance(existingModal);
                                            if (modal) modal.hide();
                                          }
                                          handleTrackFlight();
                                        }}>
                                        Track
                                        </a>
                                    </div>
                                    </div>
                                    <hr />
                                </div>
                                </div>
                            </div>
                            </div>

                            {/* Step 7 *\/}
                            <div className="step upcoming" data-index="6">
                            <div className="bullet">7</div>
                            <div className="content">
                                <div>
                                <div className="fw-bold">Arrived at Destination Airport</div>
                                <div className="small text-muted">
                                    Shipment landed at the destination airport.
                                </div>
                                </div>
                            </div>
                            </div>

                            {/* Step 8 *\/}
                            <div className="step upcoming" data-index="7">
                            <div className="bullet">8</div>
                            <div className="content">
                                <div>
                                <div className="fw-bold">Customs Clearance in Progress</div>
                                <div className="small text-muted">
                                    Shipment under customs inspection and processing.
                                </div>
                                </div>
                            </div>
                            </div>

                            {/* Step 9 *\/}
                            <div className="step upcoming" data-index="8">
                            <div className="bullet">9</div>
                            <div className="content">
                                <div>
                                <div className="fw-bold">Out for Delivery</div>
                                <div className="small text-muted">
                                    Shipment handed over for final-mile delivery.
                                </div>

                                <div className="carrier-detais-wrapper">
                                    <div className="carrier-detais">
                                    <h5 className="mb-0">
                                        <i className="eagle-base-icon-user mr-3"></i> Marcel Henry
                                    </h5>
                                    <small className="mb-0">ID #123456</small>
                                    </div>
                                    <div className="carrier-contact">
                                    <a className="btn btn-success me-2" href="">
                                        <i className="eagle-base-icon-telephone"></i>
                                    </a>
                                    <a className="btn btn-success" href="">
                                        <i className="eagle-base-icon-chat-1"></i>
                                    </a>
                                    </div>
                                </div>
                                </div>
                            </div>
                            </div>

                            {/* Step 10 *\/}
                            <div className="step upcoming" data-index="9">
                            <div className="bullet">10</div>
                            <div className="content">
                                <div>
                                <div className="fw-bold">Delivered</div>
                                <div className="small text-muted">
                                    Shipment successfully delivered to the recipient.
                                </div>
                                </div>
                            </div>
                            </div>

                            {/* Step 11 *\/}
                            <div className="step upcoming" data-index="10">
                            <div className="bullet">11</div>
                            <div className="content">
                                <div>
                                <div className="fw-bold">Completed</div>
                                <div className="small text-muted">
                                    Shipment process closed and recorded in system.
                                </div>
                                </div>
                            </div>
                            </div>

                        </div>
                        */}

                      {/* NEW DYNAMIC SHIPMENT TRACKING STEPPER */}

                      {/* <div id="vertical-stepper-dynamic" className="stepper"> */}
                      <div id="vertical-stepper-dynamic" className="">
                        {trackingLoading ? (
                          <div className="text-center py-4">
                            <div className="spinner-border text-primary" role="status">
                              <span className="visually-hidden">Loading tracking data...</span>
                            </div>
                            <p className="mt-2">Loading shipment tracking...</p>
                          </div>
                        ) : trackingData ? (
                          <>
                            {/* Main Status Display */}
                            {mainStatus && (
                              <div className="mb-4">
                                <div className="alert alert-info">
                                  <h5 className="mb-1">
                                    <i className="ti-info-alt me-2"></i>
                                    Current Status: <strong>{mainStatus.status}</strong>
                                  </h5>
                                  <small>
                                    Last updated: {new Date(mainStatus.updated_at).toLocaleString('en-GB')}
                                  </small>
                                  {mainStatus.service_provider?.full_name && (
                                    <div className="mt-2">
                                      <small>
                                        Service Provider: {mainStatus.service_provider.full_name}
                                        {mainStatus.service_provider.mobile_number && (
                                          <span> - {mainStatus.service_provider.mobile_number}</span>
                                        )}
                                      </small>
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}

                            {/* Stage-wise Tracking with Collapsible */}
                            {stageStatus.map((stageGroup, stageIndex) => {
                              const stageId = `stage-${stageGroup.stage_id}-${stageIndex}`;
                              const hasStages = stageGroup.stages && stageGroup.stages.length > 0;
                              const latestStage = hasStages ? stageGroup.stages[stageGroup.stages.length - 1] : null;
                              // 2. Format latestStage.created_at → DD-MM-YYYY
                              const stageDateObj = new Date(latestStage.created_at);
                              const stageDate = `${stageDateObj.getDate().toString().padStart(2, '0')}-${(stageDateObj.getMonth() + 1)
                                .toString()
                                .padStart(2, '0')}-${stageDateObj.getFullYear()}`;

                              // 3. Today's date → DD-MM-YYYY
                              const today = new Date();
                              const todayDate = `${today.getDate().toString().padStart(2, '0')}-${(today.getMonth() + 1)
                                .toString()
                                .padStart(2, '0')}-${today.getFullYear()}`;

                              const isToday = stageDate === todayDate;

                              const parseDMY = (dateStr) => {
                                const [day, month, year] = dateStr.split("-").map(Number);
                                return new Date(year, month - 1, day); // JS months are 0-indexed
                              };

                              const pickupDateObj = parseDMY(stageGroup.pick_up_date);
                              const dropDateObj = parseDMY(stageGroup.drop_date || stageGroup.pick_up_date);

                              const today1 = new Date();
                              today1.setHours(0, 0, 0, 0); // remove time

                              const isBetween = today1.getTime() >= pickupDateObj.getTime() && today1.getTime() <= dropDateObj.getTime();
                              const isLastStage = stageIndex === stageStatus?.length - 1;
                              return (
                                <div key={stageIndex} className="mb-3">
                                  <div className="card">
                                    {/* Collapsible Header */}
                                    <div className="card-header p-0" id={`heading-${stageId}`}>
                                      <h2 className="mb-0">
                                        <button
                                          className="btn w-100 text-start d-flex justify-content-between align-items-start"
                                          type="button"
                                          style={{
                                            background: 'transparent',
                                            border: 'none',
                                            padding: '1rem',
                                            borderRadius: '0',
                                          }}
                                          onClick={() => toggleStageExpansion(stageIndex)}
                                        >
                                          {/* LEFT SIDE (takes all width) */}
                                          <div className="d-flex align-items-start flex-grow-1 me-2">
                                            <div className="me-3">
                                              {hasStages ? (
                                                <div className="badge bg-success rounded-circle p-2">
                                                  <i className="ti-check" style={{ fontSize: '12px' }}></i>
                                                </div>
                                              ) : (
                                                <div className="badge bg-secondary rounded-circle p-2">
                                                  <i className="ti-time" style={{ fontSize: '12px' }}></i>
                                                </div>
                                              )}
                                            </div>

                                            <div className="flex-grow-1">
                                              {/* Stage Details: Mode, Route, Distance */}
                                              <div className="stage-details mb-2">
                                                <div className="d-flex align-items-center gap-2 mb-1">
                                                  <span className="badge bg-info d-flex align-items-center gap-1">
                                                    {stageGroup.mode === 'FlightCarrier' ? (
                                                      <><i className="ti-plane"></i> Flight</>
                                                    ) : (
                                                      <><i className="ti-truck"></i> Road</>
                                                    )}
                                                  </span>
                                                  {stageGroup.total_distance && (
                                                    <span className="badge bg-secondary">{stageGroup.total_distance} km</span>
                                                  )}
                                                </div>
                                                <small className="text-muted d-block">
                                                  <i className="ti-location-pin me-1"></i>
                                                  {stageGroup.origin} → {stageGroup.destination}
                                                </small>
                                                {stageGroup.mode !== 'FlightCarrier' &&
                                                  <small className="text-muted d-block">
                                                    <i className="ti-calendar me-1"></i>
                                                    {stageGroup?.pickup_date_utc
                                                      ? moment
                                                        .utc(stageGroup?.pickup_date_utc)
                                                        .local()
                                                        .format("DD-MM-YYYY")
                                                      : "N/A"}
                                                    {/* {stageGroup.pick_up_date} {stageGroup.drop_date && stageGroup.drop_date !== stageGroup.pick_up_date && `to ${stageGroup.drop_date}`} */}
                                                  </small>}
                                              </div>

                                              {latestStage && (
                                                <>
                                                  <div className="booking-details border-0 d-flex justify-content-between align-items-center">
                                                    <small className="text-muted d-block">
                                                      Latest: {latestStage.status} -{' '}
                                                      {moment.utc(latestStage.created_at).local().format("DD-MM-YYYY")}
                                                    </small>
                                                    {isLastStage &&
                                                      <small className="d-block text-dark fw-bold fs-6">
                                                        OTP: -{' '}
                                                        {stageGroup.otp_code}
                                                      </small>}
                                                  </div>

                                                  {latestStage.service_provider?.full_name && (
                                                    <div className="carrier-detais-wrapper w-100 mt-2 d-flex gap-2">
                                                      <div className="carrier-detais">
                                                        <h5 className="mb-0">
                                                          <i className="eagle-base-icon-user"></i>
                                                          {latestStage.service_provider.full_name}
                                                        </h5>
                                                        <small className="mb-0">
                                                          ID #{latestStage.service_provider.sp_id || 'N/A'}
                                                        </small>
                                                      </div>
                                                      <div className="carrier-contact">
                                                        {latestStage.service_provider.mobile_number && (
                                                          <a
                                                            className="btn btn-success me-2 btn-sm"
                                                            href={`tel:${latestStage.service_provider.mobile_number}`}
                                                          >
                                                            <i className="eagle-base-icon-telephone"></i>
                                                          </a>
                                                        )}
                                                        <button
                                                          type="button"
                                                          className="btn btn-success btn-sm"
                                                          onClick={() => setActiveChat(shipmentId)}
                                                        >
                                                          <i className="eagle-base-icon-chat-1"></i>
                                                        </button>
                                                        {activeChat && (
                                                          <ChatWidget
                                                            bookingId={activeChat}
                                                            user={userData}
                                                            sp={latestStage}
                                                            fromChatlist={false}
                                                            onClose={() => setActiveChat(null)}
                                                          />
                                                        )}
                                                      </div>
                                                    </div>
                                                  )}

                                                  {/* Transport Mode Specific Details - Show once per stage */}
                                                  {(() => {
                                                    const transportMode = stageGroup.mode === 'FlightCarrier' ? 'flight' : 'road';

                                                    if (transportMode === 'flight') {
                                                      return (
                                                        <div className="fligh-detail-wrapper mt-3">
                                                          {/* <hr />
                                                          <h5 className="mb-0">
                                                            <i className="ti-plane me-2"></i>Flight Details
                                                          </h5>
                                                          <div className="fligh-detail-1 d-flex justify-content-between align-items-center">
                                                            <div className="carrier-contact">
                                                              {(latestStage?.status !== 'boarded' && latestStage?.status !== 'Completed') && (
                                                                isFlightLoading ? (
                                                                  <div className="spinner-border spinner-border-sm" role="status">
                                                                    <span className="visually-hidden">Loading...</span>
                                                                  </div>
                                                                ) : (
                                                                  <button
                                                                    type="button"
                                                                    className={`btn btn-sm ${isBetween ? "btn-primary" : "btn-secondary disabled"}`}
                                                                    disabled={!isBetween}
                                                                    data-bs-toggle={isBetween ? "modal" : undefined}
                                                                    data-bs-target={isBetween ? "#TrackModalToggle" : undefined}
                                                                    onClick={() => {
                                                                      if (!isBetween) return;
                                                                      const existingModal = document.getElementById('TrackModalToggle');
                                                                      if (existingModal) {
                                                                        const modal = window.bootstrap.Modal.getInstance(existingModal);
                                                                        if (modal) modal.hide();
                                                                      }
                                                                      // Pass current stage and booking flight information
                                                                      const flightInfo = {
                                                                        flight_no: booking?.quote?.flight_no || stageGroup?.flight_no || latestStage?.service_provider?.flight_no,
                                                                        airline_name: booking?.quote?.airline_name || stageGroup?.airline_name || latestStage?.service_provider?.airline_name,
                                                                        pick_up_date: stageGroup?.pick_up_date,
                                                                        drop_date: stageGroup?.drop_date,
                                                                        origin: stageGroup?.origin,
                                                                        destination: stageGroup?.destination,
                                                                        service_provider: latestStage?.service_provider,
                                                                        flight_segment: stageGroup?.flight_segment // Include flight segment data for multi-segment flights
                                                                      };
                                                                      handleTrackFlight(flightInfo);
                                                                      // handleTrackFlightSegment(flightData.segments[0], 0)
                                                                    }}
                                                                  >
                                                                    <i className="ti-location-pin me-1"></i>
                                                                    Track Flight
                                                                  </button>
                                                                )
                                                              )}
                                                            </div>
                                                          </div>
                                                          <hr /> */}
                                                          {expandedStages[stageIndex] && (
                                                            <>
                                                              {stageGroup.mode === 'FlightCarrier' &&
                                                                stageStatus
                                                                  ?.filter(stage => stage.mode === "FlightCarrier")
                                                                  ?.map(stage => {
                                                                    let segments = [];

                                                                    try {
                                                                      if (stage.flight_segment) {
                                                                        segments = JSON.parse(stage.flight_segment);
                                                                      }
                                                                    } catch (e) {
                                                                      console.error("Invalid flight_segment JSON", e);
                                                                    }

                                                                    // Flight duration in hours (sum of segment durations if available)
                                                                    const flightDurationHr =
                                                                      segments.reduce((acc, seg) => {
                                                                        if (!seg.duration) return acc;
                                                                        // convert ISO 8601 duration (PTxHyM) to hours
                                                                        const match = seg.duration.match(/PT(?:(\d+)H)?(?:(\d+)M)?/);
                                                                        if (!match) return acc;
                                                                        const hours = parseInt(match[1] || 0);
                                                                        const minutes = parseInt(match[2] || 0);
                                                                        return acc + hours + minutes / 60;
                                                                      }, 0).toFixed(1);

                                                                    return (
                                                                      <div
                                                                        key={stage.stage_id}
                                                                        className="card mb-3 shadow-sm border-0"
                                                                        style={{ borderRadius: "10px" }}
                                                                      >
                                                                        <div className="card-body p-3">
                                                                          <h5>Flight Details (Stage {stage.sequence_no})</h5>

                                                                          <div className="fligh-detail-wrapper d-flex gap-3">
                                                                            <div className="fligh-detail flex-1">
                                                                              <div className="d-flex gap-3 mb-3 align-items-center">
                                                                                <img
                                                                                  src={`https://daisycon.io/images/airline/?width=120&height=80&iata=${segments?.[0]?.carrierCode}`} // Replace with dynamic logo if available
                                                                                  className="img-fluid"
                                                                                  alt="Airline Logo"
                                                                                />
                                                                                <div>
                                                                                  <h5 className="mb-0">{segments?.[0]?.carrierCode || "N/A"}</h5>
                                                                                  <p className="mb-0">
                                                                                    {segments?.map(s => s.number).join(", ") || "N/A"}
                                                                                  </p>
                                                                                </div>
                                                                              </div>

                                                                              <div className="flight-from-to no-padding d-flex justify-content-between">
                                                                                <div className="form-lo text-center">
                                                                                  {segments?.[0]?.departure
                                                                                    ? moment(parseFlightRadarTime(segments[0]?.departure)).format("DD-MM-YYYY")
                                                                                    : "N/A"}
                                                                                  <h5>
                                                                                    {segments?.[0]?.departure
                                                                                      ? parseFlightRadarTime(segments[0]?.departure).toLocaleTimeString([], {
                                                                                        hour: "2-digit",
                                                                                        minute: "2-digit",
                                                                                      })
                                                                                      : "N/A"}
                                                                                    <p style={{ marginLeft: 6 }}>
                                                                                      ({getUserTzShort()})
                                                                                    </p>
                                                                                  </h5>
                                                                                  <p className="mb-0">{stage.origin || "N/A"}</p>
                                                                                </div>

                                                                                <div className="total-time text-center">
                                                                                  <h5 className="mb-0">{flightDurationHr || "N/A"} hrs</h5>
                                                                                  <hr style={{ margin: "5px 0", borderTop: "3px solid" }} />
                                                                                  <p className="mb-0">
                                                                                    {segments.length > 1 ? `${segments.length - 1} Stop(s)` : "Non stop"}
                                                                                  </p>

                                                                                  {segments.length > 1 && (
                                                                                    <button
                                                                                      className="btn btn-link p-0 mt-1"
                                                                                      onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        setShowStops(!showStops)
                                                                                      }}
                                                                                      style={{ fontSize: "14px" }}
                                                                                    >
                                                                                      {showStops ? "Hide Stops" : "View Stops"}
                                                                                    </button>
                                                                                  )}
                                                                                </div>

                                                                                <div className="to-lo text-center">
                                                                                  {segments?.[segments.length - 1]?.arrival
                                                                                    ? moment(parseFlightRadarTime(segments[segments.length - 1].arrival)).format("DD-MM-YYYY")
                                                                                    : "N/A"}
                                                                                  <h5>
                                                                                    {segments?.[segments.length - 1]?.arrival
                                                                                      ? parseFlightRadarTime(segments[segments.length - 1].arrival).toLocaleTimeString([], {
                                                                                        hour: "2-digit",
                                                                                        minute: "2-digit",
                                                                                      })
                                                                                      : "N/A"}
                                                                                    <p style={{ marginLeft: 6 }}>
                                                                                      ({getUserTzShort()})
                                                                                    </p>
                                                                                  </h5>
                                                                                  <p className="mb-0">{stage.destination || "N/A"}</p>
                                                                                </div>
                                                                              </div>
                                                                              {segments.length == 1 &&
                                                                                <div className="d-flex justify-content-between mb-2 flex-column">
                                                                                  <button
                                                                                    // className="btn btn-primary btn-sm w-100 mt-1"
                                                                                    className={`btn btn-sm w-25 align-self-end track-btn ${getShowTrackBtn(segments[0]) ? "btn-primary" : "btn-secondary"}`}
                                                                                    disabled={!getShowTrackBtn(segments[0])}
                                                                                    data-bs-toggle={getShowTrackBtn(segments[0]) ? "modal" : undefined}
                                                                                    data-bs-target={getShowTrackBtn(segments[0]) ? "#TrackModalToggle" : undefined}
                                                                                    onClick={(e) => {
                                                                                      if (!getShowTrackBtn(segments[0])) return;
                                                                                      const existingModal = document.getElementById('TrackModalToggle');
                                                                                      if (existingModal) {
                                                                                        const modal = window.bootstrap.Modal.getInstance(existingModal);
                                                                                        if (modal) modal.hide();
                                                                                      }
                                                                                      // Pass current stage and booking flight information
                                                                                      const flightInfo = {
                                                                                        flight_no: booking?.quote?.flight_no || stageGroup?.flight_no || latestStage?.service_provider?.flight_no,
                                                                                        airline_name: booking?.quote?.airline_name || stageGroup?.airline_name || latestStage?.service_provider?.airline_name,
                                                                                        pick_up_date: stageGroup?.pick_up_date,
                                                                                        drop_date: stageGroup?.drop_date,
                                                                                        origin: stageGroup?.origin,
                                                                                        destination: stageGroup?.destination,
                                                                                        service_provider: latestStage?.service_provider,
                                                                                        flight_segment: stageGroup?.flight_segment // Include flight segment data for multi-segment flights
                                                                                      };
                                                                                      e.stopPropagation();
                                                                                      setTrackIndex(0)
                                                                                      getSourceLatLng(stage.origin)
                                                                                      getDestLatLng(stage.destination)
                                                                                      handleTrackFlight(flightInfo, 0);
                                                                                      // handleTrackFlightSegment(seg, idx)
                                                                                      handleTrackFlightSegment(flightData?.segments[0], 0)
                                                                                    }}
                                                                                  >
                                                                                    Track
                                                                                  </button>
                                                                                </div>
                                                                              }
                                                                              {/* Track Button (15 min before departure → until arrival) */}
                                                                              {segments.map((seg, idx) => {
                                                                                const now = new Date();

                                                                                const departureTime = parseFlightRadarTime(seg.departure);
                                                                                const arrivalTime = parseFlightRadarTime(seg.arrival);

                                                                                const showTrackBtn =
                                                                                  departureTime &&
                                                                                  arrivalTime &&
                                                                                  now >= new Date(departureTime.getTime() - 15 * 60 * 1000) &&
                                                                                  now <= arrivalTime;


                                                                                return (
                                                                                  !showTrackBtn && (
                                                                                    <></>
                                                                                    // <button
                                                                                    //   key={idx}
                                                                                    //   className="btn btn-primary btn-sm w-100 mt-2"
                                                                                    //   // onClick={() => handleTrackFlightSegment(seg, idx)}
                                                                                    //   onClick={(e) => {
                                                                                    //     if (!isBetween) return;
                                                                                    //     const existingModal = document.getElementById('TrackModalToggle');
                                                                                    //     if (existingModal) {
                                                                                    //       const modal = window.bootstrap.Modal.getInstance(existingModal);
                                                                                    //       if (modal) modal.hide();
                                                                                    //     }
                                                                                    //     // Pass current stage and booking flight information
                                                                                    //     const flightInfo = {
                                                                                    //       flight_no: booking?.quote?.flight_no || stageGroup?.flight_no || latestStage?.service_provider?.flight_no,
                                                                                    //       airline_name: booking?.quote?.airline_name || stageGroup?.airline_name || latestStage?.service_provider?.airline_name,
                                                                                    //       pick_up_date: stageGroup?.pick_up_date,
                                                                                    //       drop_date: stageGroup?.drop_date,
                                                                                    //       origin: stageGroup?.origin,
                                                                                    //       destination: stageGroup?.destination,
                                                                                    //       service_provider: latestStage?.service_provider,
                                                                                    //       flight_segment: stageGroup?.flight_segment // Include flight segment data for multi-segment flights
                                                                                    //     };
                                                                                    //     e.stopPropagation();
                                                                                    //     handleTrackFlight(flightInfo);
                                                                                    //     // handleTrackFlightSegment(seg, idx)
                                                                                    //     handleTrackFlightSegment(flightData.segments[idx], idx)
                                                                                    //   }}
                                                                                    // >
                                                                                    //   Track
                                                                                    // </button>
                                                                                  )
                                                                                );
                                                                              })}
                                                                              {/* Expanded Stops List */}
                                                                              {showStops && (
                                                                                <div
                                                                                  className="my-2 p-2 border rounded bg-light"
                                                                                  onClick={(e) => e.stopPropagation()} // prevent outer click
                                                                                >
                                                                                  {segments.map((seg, index) => {
                                                                                    const now = new Date();

                                                                                    const departureTime = parseFlightRadarTime(seg.departure);
                                                                                    const arrivalTime = parseFlightRadarTime(seg.arrival);

                                                                                    const showTrackBtn =
                                                                                      departureTime &&
                                                                                      arrivalTime &&
                                                                                      now >= new Date(departureTime.getTime() - 15 * 60 * 1000) &&
                                                                                      now <= arrivalTime;


                                                                                    return (
                                                                                      <div key={index} className="d-flex justify-content-between mb-2 flex-column">
                                                                                        <div className="d-flex align-items-center justify-content-between w-100 my-2">

                                                                                          {/* From */}
                                                                                          <div className="text-start">
                                                                                            <strong>From:</strong> {seg.departure.iataCode}
                                                                                            <br />
                                                                                            <span>
                                                                                              {seg?.departure?.at_utc
                                                                                                ? moment
                                                                                                  .utc(seg.departure?.at_utc)
                                                                                                  .local()
                                                                                                  .format("DD-MM-YYYY")
                                                                                                : "N/A"}
                                                                                              <br />
                                                                                              {parseFlightRadarTime(seg?.departure)?.toLocaleTimeString([], {
                                                                                                hour: "2-digit",
                                                                                                minute: "2-digit",
                                                                                              }) ?? "N/A"}   ({getUserTzShort()})
                                                                                            </span>
                                                                                          </div>

                                                                                          {/* Dotted Line with Airplane */}
                                                                                          <div className="flight-middle flex-grow-1 px-2 bg-light align-self-center">
                                                                                            <div className="flight-line"></div>
                                                                                            <span className="flight-icon bg-light">✈</span>
                                                                                          </div>

                                                                                          {/* To */}
                                                                                          <div className="text-end">
                                                                                            <strong>To:</strong> {seg.arrival.iataCode}
                                                                                            <br />
                                                                                            <span>
                                                                                              {seg?.arrival?.at_utc
                                                                                                ? moment
                                                                                                  .utc(seg.arrival?.at_utc)
                                                                                                  .local()
                                                                                                  .format("DD-MM-YYYY")
                                                                                                : "N/A"}
                                                                                              <br />
                                                                                              {parseFlightRadarTime(seg?.arrival)?.toLocaleTimeString([], {
                                                                                                hour: "2-digit",
                                                                                                minute: "2-digit",
                                                                                              }) ?? "N/A"}    ({getUserTzShort()})
                                                                                            </span>
                                                                                          </div>

                                                                                        </div>


                                                                                        {/* Track Button inside stops list */}
                                                                                        {/* {showTrackBtn && ( */}
                                                                                        <button
                                                                                          // className="btn btn-primary btn-sm w-100 mt-1"
                                                                                          className={`btn btn-sm w-25 align-self-end track-btn ${showTrackBtn ? "btn-primary" : "btn-secondary"}`}
                                                                                          disabled={!showTrackBtn}
                                                                                          data-bs-toggle={showTrackBtn ? "modal" : undefined}
                                                                                          data-bs-target={showTrackBtn ? "#TrackModalToggle" : undefined}
                                                                                          onClick={(e) => {
                                                                                            if (!showTrackBtn) return;
                                                                                            const existingModal = document.getElementById('TrackModalToggle');
                                                                                            if (existingModal) {
                                                                                              const modal = window.bootstrap.Modal.getInstance(existingModal);
                                                                                              if (modal) modal.hide();
                                                                                            }
                                                                                            // Pass current stage and booking flight information
                                                                                            const flightInfo = {
                                                                                              flight_no: booking?.quote?.flight_no || stageGroup?.flight_no || latestStage?.service_provider?.flight_no,
                                                                                              airline_name: booking?.quote?.airline_name || stageGroup?.airline_name || latestStage?.service_provider?.airline_name,
                                                                                              pick_up_date: stageGroup?.pick_up_date,
                                                                                              drop_date: stageGroup?.drop_date,
                                                                                              origin: stageGroup?.origin,
                                                                                              destination: stageGroup?.destination,
                                                                                              service_provider: latestStage?.service_provider,
                                                                                              flight_segment: stageGroup?.flight_segment // Include flight segment data for multi-segment flights
                                                                                            };
                                                                                            e.stopPropagation();
                                                                                            setTrackIndex(index)
                                                                                            getSourceLatLng(seg.departure.iataCode)
                                                                                            getDestLatLng(seg.arrival.iataCode)
                                                                                            handleTrackFlight(flightInfo, index);
                                                                                            // handleTrackFlightSegment(seg, idx)
                                                                                            handleTrackFlightSegment(flightData?.segments[index], index)
                                                                                          }}
                                                                                        >
                                                                                          Track
                                                                                        </button>

                                                                                      </div>
                                                                                    );
                                                                                  })}
                                                                                </div>
                                                                              )}

                                                                            </div>
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    );
                                                                  })}
                                                            </>
                                                          )}

                                                        </div>
                                                      );
                                                    } else if (transportMode === 'road' && latestStage?.service_provider?.full_name) {
                                                      return (
                                                        <div className="delivery-tracking-wrapper mt-3">

                                                          <div className="delivery-detail d-flex justify-content-between align-items-center">

                                                            <div className="carrier-contact">
                                                              {['Pickup', 'InTransit'].includes(latestStage?.status) && isToday ? (

                                                                <a
                                                                  className="btn btn-warning"
                                                                  data-bs-toggle="modal"
                                                                  href="#DeliveryTrackModalToggle"
                                                                  onClick={() => {
                                                                    setCurrentStage(stageGroup)
                                                                    // handleTrackDeliveryPerson(latestStage.service_provider, stageGroup)
                                                                  }}
                                                                >
                                                                  <i className="ti-location-pin me-1"></i>
                                                                  Track Location
                                                                </a>
                                                              ) : null}
                                                            </div>
                                                          </div>

                                                        </div>
                                                      );
                                                    }
                                                    return null;
                                                  })()}
                                                </>
                                              )}

                                              {!hasStages && <small className="text-muted">No updates yet</small>}
                                            </div>
                                          </div>

                                          {/* RIGHT SIDE (arrow icon stays small) */}
                                          <i
                                            className={`ti-angle-${expandedStages[stageIndex] ? 'up' : 'down'}`}
                                            style={{
                                              transition: 'transform 0.3s ease',
                                            }}
                                          ></i>
                                        </button>

                                      </h2>
                                    </div>

                                    {/* Collapsible Content */}
                                    {expandedStages[stageIndex] && (
                                      <div className="card-body stepper" style={{
                                        animation: 'fadeIn 0.3s ease-in-out'
                                      }}>
                                        {hasStages ? (
                                          <div className="timeline-wrapper">
                                            {stageGroup.stages.map((stage, stepIndex) => {
                                              const isLastInStage = stepIndex === stageGroup.stages.length - 1;
                                              const stepClass = isLastInStage ? "step active" : "step completed";

                                              return (
                                                <div key={stepIndex} className={stepClass} data-index={stepIndex}>
                                                  <div className="bullet" aria-hidden="true">
                                                    {stepClass === "step completed" ? (
                                                      <i className="ti-check"></i>
                                                    ) : (
                                                      stepIndex + 1
                                                    )}
                                                  </div>
                                                  <div className="content">
                                                    <div>
                                                      <div className="fw-bold">{stage.status}</div>
                                                      <div className="small text-muted">
                                                        {getStatusDescription(stage.status)}
                                                      </div>
                                                      <div className="time">
                                                        {new Date(stage.created_at).toLocaleString('en-GB')}
                                                      </div>
                                                      {/* Service Provider Details */}
                                                      {/* {stage.service_provider && stage.service_provider.full_name && (
                                                          <div className="carrier-detais-wrapper mt-2">
                                                            <div className="carrier-detais">
                                                              <h5 className="mb-0">
                                                                <i className="eagle-base-icon-user mr-3"></i>
                                                                {stage.service_provider.full_name}
                                                              </h5>
                                                              <small className="mb-0">
                                                                ID #{stage.service_provider.sp_id || 'N/A'}
                                                              </small>
                                                            </div>
                                                            <div className="carrier-contact">
                                                              {stage.service_provider.mobile_number && (
                                                                <a 
                                                                  className="btn btn-success me-2" 
                                                                  href={`tel:${stage.service_provider.mobile_number}`}
                                                                >
                                                                  <i className="eagle-base-icon-telephone"></i>
                                                                </a>
                                                              )}
                                                              <a className="btn btn-success" href="#">
                                                                <i className="eagle-base-icon-chat-1"></i>
                                                              </a>
                                                            </div>
                                                          </div>
                                                        )} */}
                                                    </div>
                                                  </div>
                                                </div>
                                              );
                                            })}
                                          </div>
                                        ) : (
                                          <div className="text-muted p-3 text-center">
                                            <i className="ti-info-alt me-2"></i>
                                            No tracking updates available for this stage yet.
                                          </div>
                                        )}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                          </>
                        ) : (
                          <div className="text-center py-4">
                            <div className="alert alert-warning">
                              <i className="ti-alert-triangle me-2"></i>
                              No tracking information available for this shipment yet.
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right Side */}
                <div className="col-xl-6 col-lg-12 col-md-6">
                  {/* Payment Details */}
                  <div className="card mb-3">
                    <div className="card-body">
                      <div className="mb-0">
                        <h3 className="commen-h3-title mb-0">Payment Details</h3>
                      </div>
                      <hr />


                      {/* Flight Details - only show if flight data exists */}
                      {booking?.quote && (booking.quote.airline_name || booking.quote.flight_no) && (

                        <>
                          <h5>Flight Details</h5>
                          <div className="fligh-detail-wrapper">
                            <div className="fligh-detail flex-1">
                              <div className="d-flex gap-3 mb-3">
                                <img
                                  src={booking?.quote?.airline_image || "/images/UnitedAirlines.svg"}
                                  className="img-fluid"
                                  style={{ maxWidth: "50px" }}
                                  alt="airline"
                                />
                                <div>
                                  <h5 className="mb-0">{booking?.quote?.airline_name || 'United Airlines'}</h5>
                                  <p className="mb-0">{booking?.quote?.flight_no || 'UA 2608'}</p>
                                </div>
                              </div>

                              <div className="flight-from-to">
                                <div className="form-lo text-center">
                                  <h5 className="mb-0">{booking?.quote?.departure_time || '01:50'}</h5>
                                  <p className="mb-0">{booking?.quote?.departure_city || 'Alexandria'}</p>
                                </div>
                                <div className="total-time text-center">
                                  <h5 className="mb-0">{booking?.quote?.duration || '04h 15m'}</h5>
                                  <hr style={{ margin: "5px 0", borderTop: "3px solid" }} />
                                  <p className="mb-0">{booking?.quote?.stop || 'Non stop'}</p>
                                </div>
                                <div className="to-lo text-center">
                                  <h5 className="mb-0">{booking?.quote?.arrival_time || '08:05'}</h5>
                                  <p className="mb-0">{booking?.quote?.arrival_city || 'Sterling'}</p>
                                </div>
                              </div>
                            </div>

                            <div className="fligh-cost">
                              <h5 className="mb-0">Total Flight Charges</h5>
                              <h5 className="mb-0">{booking?.currency_symbol || ""}{booking?.quote?.total_charges || 0}</h5>
                            </div>
                          </div>
                        </>
                      )}


                      {/* Carrier Charges */}

                      {/* <h5>Carrier Charges</h5> */}
                      <div className="fligh-detail-wrapper">
                        {/* <div className="fligh-detail flex-1">
                                <div className="d-flex gap-3 mb-1 justify-content-between">
                                <p className="mb-0">Carrier Fees</p>
                                <p className="mb-0">{booking?.currency_symbol || ""}{booking?.quote?.carrier_fees || 0}</p>
                                </div>
                                <div className="d-flex gap-3 mb-1 justify-content-between">
                                <p className="mb-0">Pick Up Charges</p>
                                <p className="mb-0">{booking?.currency_symbol || ""}{booking?.quote?.pick_up_charges || 0}</p>
                                </div>
                                <div className="d-flex gap-3 mb-1 justify-content-between">
                                <p className="mb-0">Drop-off Charges</p>
                                <p className="mb-0">{booking?.currency_symbol || ""}{booking?.quote?.drop_off_charges || 0}</p>
                                </div>
                            </div> */}
                        <div className="fligh-cost">
                          <h5 className="mb-0">Total Carrier Charges</h5>
                          <h5 className="mb-0">{booking?.currency_symbol || ""}{booking?.quote?.total_carrier_charges || 0}</h5>
                        </div>
                      </div>

                      {/* Handling Charges */}
                      <hr />
                      <h5>Handling Charges</h5>
                      <div className="fligh-detail-wrapper">
                        <div className="fligh-detail flex-1">
                          <div className="d-flex gap-3 mb-1 justify-content-between">
                            <p className="mb-0">Custom Clearance Charges</p>
                            <p className="mb-0">{booking?.currency_symbol || ""}{booking?.quote?.custom_clearance_charges || 0}</p>
                          </div>
                          <div className="d-flex gap-3 mb-1 justify-content-between">
                            <p className="mb-0">Documentation Charges</p>
                            <p className="mb-0">{booking?.currency_symbol || ""}{booking?.quote?.documentation_charges || 0}</p>
                          </div>
                          <div className="d-flex gap-3 mb-1 justify-content-between">
                            <p className="mb-0">Other Charges</p>
                            <p className="mb-0">{booking?.currency_symbol || ""}{booking?.quote?.other_charges || 0}</p>
                          </div>
                        </div>
                        <div className="fligh-cost mb-1">
                          <h5 className="mb-0">Total Handling Charges</h5>
                          <h5 className="mb-0">{booking?.currency_symbol || ""}{booking?.quote?.total_handling_charges || 0}</h5>
                        </div>
                        <div className="fligh-cost mb-1">
                          <h5 className="mb-0">Service Charges</h5>
                          <h5 className="mb-0">{booking?.currency_symbol || ""}{booking?.quote?.admin_commission_charges || 0}</h5>
                        </div>
                        <div className="fligh-cost d-flex justify-content-between align-items-center">
                          <div className="d-flex align-items-center gap-1">
                            <h5 className="mb-0">Any Other Charges</h5>

                            <span
                              title={
                                Array.isArray(booking?.extra_charges) &&
                                  booking.extra_charges.length > 0
                                  ? booking.extra_charges
                                    .map(
                                      (c) =>
                                        `${c?.charge_name || "Charge"}: ${booking?.currency_symbol || ""
                                        }${c?.charge_value ?? 0}`
                                    )
                                    .join("\n")
                                  : "No extra charges"
                              }
                              style={{
                                cursor: "pointer",
                                fontSize: "11px",
                                color: "#6c757d",
                                border: "1px solid #6c757d",
                                borderRadius: "50%",
                                width: "16px",
                                height: "16px",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                lineHeight: "1",
                              }}
                            >
                              ℹ
                            </span>
                          </div>

                          <h5 className="mb-0">
                            {booking?.currency_symbol || ""}
                            {booking?.total_extra_charges || 0}
                          </h5>
                        </div>
                      </div>

                      {/* Paid Amount */}
                      <hr />
                      <div className="fligh-cost">
                        <h5 className="mb-0">Paid Amount</h5>
                        <h3 className="commen-h3-title mb-0">{booking?.currency_symbol || ""}{booking?.quote?.total_pay_amount || 0}</h3>
                      </div>

                      <hr />
                      {booking?.paymentTransactionHistory?.status == "Pending" || booking?.paymentTransactionHistory == null ?
                        <>
                          <button
                            className="btn btn-success btn-lg w-100 my-2"
                            onClick={handlePayNow}
                            disabled={checkoutLoading}
                          >
                            {checkoutLoading ? "Processing..." : "Pay Now"}
                          </button>
                          {booking?.status == "Delivered" &&
                            <p
                              style={{
                                color: "red",
                                marginVertical: "10px",
                                paddingLeft: "10px",
                              }}
                            >
                              {booking?.payment_info?.remaining_days === 0
                                ? "Immediate payment required."
                                : booking?.payment_info?.payment_due_in}
                            </p>}
                        </>
                        :
                        <>
                          <h5>Transaction Details</h5>
                          <div className="fligh-detail-wrapper">
                            <div className="fligh-detail flex-1">
                              <div className="d-flex gap-3 mb-1 justify-content-between">
                                <p className="mb-0">Payment Status</p>
                                <p className="mb-0 text-success fw-bold">{booking?.paymentTransactionHistory?.status || '-'}</p>
                              </div>
                              <div className="d-flex gap-3 mb-1 justify-content-between">
                                <p className="mb-0">Transaction Id</p>
                                <p className="mb-0">{booking?.paymentTransactionHistory?.stripe_transaction_id || '-'}</p>
                              </div>
                              <div className="d-flex gap-3 mb-1 justify-content-between">
                                <p className="mb-0">Payment Mode</p>
                                <p className="mb-0">{booking?.paymentTransactionHistory?.payment_method || '-'}</p>
                              </div>
                            </div>
                          </div>
                        </>
                      }

                    </div>
                  </div>
                  <div className="shipment-details-new p-0">
                    {/* Shipment Details */}
                    <div className="card mb-3">
                      <div className="card-body">
                        <div className="mb-0">
                          <h3 className="commen-h3-title mb-0">Shipment Details</h3>
                        </div>
                        <hr />
                        <div className="form-to-location">
                          <div className="form-location">
                            <div className="icon-ftl">
                              <i className="ti-arrow-up"></i>
                            </div>
                            <div className="flex-1">
                              <label>Pickup</label>
                              <h3>{booking?.pickup_address?.address_type}</h3>
                              <span>
                                {booking?.pickup_address?.address}, {booking?.pickup_address?.city}, {booking?.pickup_address?.state}, {booking?.pickup_address?.zip_code}
                              </span>
                            </div>
                          </div>

                          <div className="to-location">
                            <div className="icon-ftl">
                              <i className="ti-arrow-down"></i>
                            </div>
                            <div className="flex-1">
                              <label>Drop-off</label>
                              <h3>{booking?.drop_address?.address_type || 'N/A'}</h3>
                              <span>
                                {booking?.drop_address?.address}, {booking?.drop_address?.city || ''}, {booking?.drop_address?.state || ''}, {booking?.drop_address?.zip_code || ''}
                              </span>
                            </div>
                          </div>
                        </div>

                        <hr />
                        <h5>Product Details</h5>
                        <div className="row">
                          {booking?.items?.map((item, index) => (
                            <div className="col-lg-6" key={index}>
                              <div className="shipment-item-container">
                                <div className="shipment-item-img">
                                  <img src={item?.item_image || "/images/defaultImage.jpg"} className="img-fluid" alt={item?.item_name || "item"} />
                                </div>
                                <div className="shipment-item-details">
                                  <h5>{item?.item_name}</h5>
                                  <p className="small mb-1">{item?.item_description}</p>
                                  <p className="small mb-1">
                                    Size: Height {item?.item_height} cm × Width {item?.item_width} cm × Length {item?.item_length} cm
                                  </p>
                                  <p className="small mb-1">Box Weight: {item?.item_weight} kg</p>
                                  <p className="small mb-1">Quantity: {item?.item_qty}</p>
                                  <p className="small mb-1">Total Weight: {item?.item_qty * item?.item_weight} kg</p>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>

                        <hr />
                        <h5>Pickup Time</h5>
                        <p className="mb-0">
                          {booking?.pickup_date
                            ? moment.utc(booking.pickup_date).local().format("ddd, MMM DD")
                            : "N/A"}, {booking?.pickup_time}
                        </p>
                        <p className="mb-0">Urgency level: {booking?.urgency_level}</p>
                      </div>
                    </div>


                  </div>
                </div>
              </div>
            </div>
            {/* End Main */}
          </div>
        </div>
      </section>
      {/* Documents Modal */}
      <div
        className="modal fade"
        id="documentModalToggle"
        tabIndex="-1"
        aria-labelledby="documentModalToggleLabel"
        aria-hidden="true"
        ref={documentsModalRef}
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="documentModalToggleLabel">
                My Documents
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => handleCloseModal("documentModalToggle")}
              ></button>
            </div>

            <div className="modal-body">
              {successMessage && (
                <div className="alert alert-success">{successMessage}</div>
              )}
              <div className="row">
                <div className="col-lg-12">
                  <div className="row">
                    {documents && documents.length > 0 ? (
                      documents.map((doc, idx) => (
                        <div className="col-6 col-lg-4" key={idx}>
                          <div className="card doc-list-wrapper">
                            {doc.doc_file.endsWith(".pdf") ? (
                              <div className="pdf-icon-wrapper text-center p-4">
                                <img
                                  src="/images/pdf.png"
                                  alt="PDF"
                                  style={{ width: "80px", height: "80px" }}
                                />
                              </div>

                            ) : (
                              <img
                                src={doc.doc_file}
                                className="card-img-top"
                                alt={doc.doc_name}
                              />
                            )}

                            <a
                              className="close-icon"
                              onClick={() => {
                                // if (window.confirm("Do you want to delete this document?")) {
                                handleDeleteDocument(doc.doc_id);
                                // }
                              }}
                            >
                              <i className="ti-close"></i>
                            </a>


                            <div className="card-body">
                              <h5 className="card-title">{doc.doc_name}</h5>
                              <p className="card-text">{doc.doc_description}</p>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="col-12 text-center my-5">
                        <img
                          src="/images/nodatafoundimg.png" // replace with your image path
                          alt="No documents found"
                          className="img-fluid mb-3"
                          style={{ maxWidth: "200px" }}
                        />
                        <p>No documents found.</p>
                      </div>
                    )}

                    <div className="col-md-12 mt-3">

                      <button
                        className="btn btn-success btn-lg w-100"
                        onClick={() => {
                          const documentsModalEl = document.getElementById("documentModalToggle");
                          const addModalEl = document.getElementById("adddocumentModalToggle");

                          const documentsModal = window.bootstrap.Modal.getInstance(documentsModalEl);

                          if (documentsModal) {
                            // Listen for "hidden" event before opening the Add modal
                            documentsModalEl.addEventListener(
                              "hidden.bs.modal",
                              () => {
                                const addModal = window.bootstrap.Modal.getOrCreateInstance(addModalEl);
                                addModal.show();
                              },
                              { once: true } // run only once
                            );

                            documentsModal.hide();
                          } else {
                            // fallback, just show Add modal
                            const addModal = window.bootstrap.Modal.getOrCreateInstance(addModalEl);
                            addModal.show();
                          }
                        }}
                      >
                        Add New Document
                      </button>


                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>


      {/* Add Document Modal */}
      <div
        className="modal fade"
        id="adddocumentModalToggle"
        tabIndex="-1"
        aria-hidden="true"
        ref={addModalRef}
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Document</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={() => handleCloseModal("adddocumentModalToggle")}></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleAddDocument}>
                <div className="mb-3">
                  <label className="form-label">Document Title</label>
                  <input
                    className={`form-control doc_formgroup ${errors.docName ? "is-invalid" : ""}`}
                    type="text"
                    value={docName}
                    onChange={(e) => setDocName(e.target.value)}
                  />
                  {errors.docName && <div className="invalid-feedback">{errors.docName}</div>}
                </div>

                <div className="mb-3">
                  <label className="form-label">Description</label>
                  <textarea
                    className={`form-control doc_formgroup ${errors.docDescription ? "is-invalid" : ""}`}
                    rows="2"
                    value={docDescription}
                    onChange={(e) => setDocDescription(e.target.value)}
                  ></textarea>
                  {errors.docDescription && (
                    <div className="invalid-feedback">{errors.docDescription}</div>
                  )}
                </div>

                <div className="mb-3">
                  <label className="form-label">Upload Document</label>
                  <input
                    className={`form-control doc_formgroup ${errors.docFile ? "is-invalid" : ""}`}
                    type="file"
                    ref={fileInputRef}
                    onChange={(e) => setDocFile(e.target.files[0])}
                  />
                  {errors.docFile && <div className="invalid-feedback">{errors.docFile}</div>}
                </div>

                <div className="mb-3">
                  <button type="submit" className="btn btn-success w-100">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>


      {/* Track Modal */}
      {/* Track Modal */}
      <div
        className="modal fade commen-popup"
        id="TrackModalToggle"
        tabIndex="-1"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        onShown={() => {
          // ✅ FIX #1: Trigger map resize when modal becomes visible
          if (window.google?.maps) {
            setTimeout(() => {
              window.google.maps.event.trigger(window, "resize");
            }, 300);
          }
        }}
      >
        <div
          className="modal-dialog modal-xl modal-dialog-centered"
          style={{
            width: "calc(100% - 40px)",
            height: "calc(100% - 40px)",
            margin: "20px",
            maxWidth: "none",
          }}
        >
          <div
            className="modal-content"
            style={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              className="modal-body p-0 position-relative flex-grow-1"
              style={{ height: "100%", overflow: "hidden" }}
            >
              {/* Close Button */}
              <button
                type="button"
                className="btn-close position-absolute bg-white rounded-circle p-2 shadow"
                aria-label="Close"
                style={{
                  top: "15px",
                  right: "65px",
                  zIndex: 9999,
                  border: "2px solid #ddd",
                }}
                onClick={() => {
                  const modal = window.bootstrap.Modal.getInstance(document.getElementById('TrackModalToggle'));
                  if (modal) {
                    modal.hide();
                    // Clean up modal backdrop and body classes
                    setTimeout(() => {
                      const backdrops = document.querySelectorAll('.modal-backdrop');
                      backdrops.forEach(backdrop => backdrop.remove());
                      document.body.classList.remove('modal-open');
                      document.body.style.overflow = '';
                      document.body.style.paddingRight = '';
                    }, 300);
                  }
                }}
              ></button>

              {/* Map or Error View */}
              <div style={{ height: "600px", width: "100%" }}>
                {!isLoaded ? (
                  <div className="d-flex justify-content-center align-items-center h-100">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading map...</span>
                    </div>
                    <span className="ms-2">Loading map...</span>
                  </div>
                ) : isFlightLoading ? (
                  <div className="d-flex justify-content-center align-items-center h-100">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading flight data...</span>
                    </div>
                    <span className="ms-2">Loading flight data...</span>
                  </div>
                ) : errorMessage ? (
                  <div
                    className="d-flex flex-column justify-content-center align-items-center h-100 text-center p-5"
                    style={{
                      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                      borderRadius: "15px",
                      position: "relative",
                      overflow: "hidden"
                    }}
                  >
                    {/* Background Pattern */}
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Ccircle cx='30' cy='30' r='4'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
                        opacity: 0.3
                      }}
                    />

                    {/* Content */}
                    <div className="position-relative z-index-1" style={{ zIndex: 2 }}>
                      {/* Flight Icon */}
                      <div className="mb-4">
                        <div
                          className="d-inline-flex align-items-center justify-content-center rounded-circle"
                          style={{
                            width: "120px",
                            height: "120px",
                            background: "rgba(255,255,255,0.2)",
                            backdropFilter: "blur(10px)",
                            border: "2px solid rgba(255,255,255,0.3)"
                          }}
                        >
                          <svg
                            width="48"
                            height="48"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{
                              color: "#ffffff",
                              transform: "rotate(-45deg)"
                            }}
                          >
                            <path
                              d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"
                              fill="currentColor"
                            />
                          </svg>
                        </div>
                      </div>

                      {/* Title */}
                      <h3 className="text-white fw-bold mb-3">
                        Flight Not Available
                      </h3>

                      {/* Message */}
                      <div
                        className="alert alert-light border-0 mb-4"
                        style={{
                          background: "rgba(255,255,255,0.9)",
                          backdropFilter: "blur(10px)",
                          borderRadius: "12px",
                          maxWidth: "500px"
                        }}
                      >
                        <div className="d-flex align-items-center">
                          <i className="ti-info-alt text-primary me-3" style={{ fontSize: "24px" }}></i>
                          <div className="text-start">
                            <h6 className="mb-1 text-dark">Flight Information Unavailable</h6>
                            <p className="mb-0 text-muted small">
                              {errorMessage.includes('No flight summary found')
                                ? 'No flight data found for the specified date range. The flight might be scheduled for a different time or the tracking information is not yet available.'
                                : errorMessage
                              }
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* Action Buttons */}
                      <div className="d-flex gap-3 justify-content-center flex-wrap">
                        <button
                          className="btn btn-light btn-lg px-4"
                          onClick={() => {
                            const modal = window.bootstrap.Modal.getInstance(document.getElementById('TrackModalToggle'));
                            if (modal) {
                              modal.hide();
                              // Remove any lingering backdrop
                              setTimeout(() => {
                                const backdrops = document.querySelectorAll('.modal-backdrop');
                                backdrops.forEach(backdrop => backdrop.remove());
                                document.body.classList.remove('modal-open');
                                document.body.style.overflow = '';
                                document.body.style.paddingRight = '';
                              }, 300);
                            }
                          }}
                          style={{
                            borderRadius: "25px",
                            fontWeight: "500",
                            minWidth: "120px"
                          }}
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="me-2"
                          >
                            <path d="M19 12H5M12 19l-7-7 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                          Go Back
                        </button>

                        <button
                          className="btn btn-outline-light btn-lg px-4"
                          onClick={() => {
                            // Retry flight tracking with the same flight info
                            handleTrackFlight(currentFlightInfo);
                          }}
                          style={{
                            borderRadius: "25px",
                            fontWeight: "500",
                            minWidth: "120px",
                            borderColor: "rgba(255,255,255,0.5)",
                            color: "#ffffff"
                          }}
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="me-2"
                          >
                            <path d="M1 4v6h6M23 20v-6h-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                          Try Again
                        </button>
                      </div>

                      {/* Help Text */}
                      <div className="mt-4">
                        <small className="text-white-50">
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="me-1"
                          >
                            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                            <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M12 17h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                          Flight tracking data is provided by third-party services and may not be available for all flights.
                        </small>
                      </div>
                    </div>
                  </div>
                ) : flightData?.isMultiSegment ? (
                  // Multi-segment flight display
                  <div style={{ position: "relative", width: "100%", height: "100%", display: "flex" }}>
                    {/* Multi-Segment Flight Header */}
                    <div
                      className="position-absolute alert alert-primary border-0 m-2 py-2 px-3"
                      style={{
                        top: "10px",
                        left: "10px",
                        zIndex: 1000,
                        background: "rgba(13, 110, 253, 0.95)",
                        borderRadius: "8px",
                        fontSize: "12px",
                        fontWeight: "500",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                        color: "white",
                        maxWidth: "300px"
                      }}
                    >
                      <i className="ti-plane me-1"></i>
                      <strong>Multi-Segment Flight Journey</strong>
                      <br />
                      <small>{flightData.segments.length} connecting flights</small>
                    </div>

                    {/* Flight Segments Panel - 30% width */}
                    <div
                      className="bg-white shadow-lg"
                      style={{
                        width: "30%",
                        height: "100%",
                        overflowY: "auto",
                        borderRadius: "12px 0 0 12px",
                        zIndex: 1000,
                        border: "1px solid #e0e0e0",
                        borderRight: "none"
                      }}
                    >
                      <div className="p-3" style={{ height: "100%" }}>
                        <div className="d-flex align-items-center justify-content-between mb-3">
                          <h6 className="mb-0 fw-bold text-primary">
                            <i className="ti-plane me-2"></i>
                            Flight Journey
                          </h6>
                          <span className="badge bg-primary">{flightData.segments.length} Segments</span>
                        </div>

                        {/* Journey Overview */}
                        <div className="mb-3 p-3 bg-light rounded border">
                          <div className="text-center">
                            <div className="row align-items-center">
                              <div className="col-5">
                                <div className="fw-bold text-success fs-6">
                                  {flightData.segments[0].departure.airport}
                                </div>
                                <small className="text-muted">Origin</small>
                              </div>
                              <div className="col-2">
                                <div className="d-flex align-items-center justify-content-center">
                                  <div style={{
                                    width: '30px',
                                    height: '2px',
                                    background: 'linear-gradient(90deg, #28a745, #dc3545)',
                                    borderRadius: '2px',
                                    position: 'relative'
                                  }}>
                                    <i className="ti-plane" style={{
                                      position: 'absolute',
                                      top: '-8px',
                                      right: '-5px',
                                      fontSize: '12px',
                                      color: '#007bff'
                                    }}></i>
                                  </div>
                                </div>
                              </div>
                              <div className="col-5">
                                <div className="fw-bold text-danger fs-6">
                                  {flightData.segments[flightData.segments.length - 1].arrival.airport}
                                </div>
                                <small className="text-muted">Destination</small>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Individual Segments */}
                        {flightData.segments
                          .filter((_, index) => selectedSegment === index)
                          .map((segment, index) => (
                            <div key={index} className="mb-3">
                              <div
                                className={`card border text-dark cursor-pointer`}
                                style={{ cursor: 'pointer', transition: 'all 0.3s ease', background: '#d4edda' }}
                                onClick={() => { }}
                              >
                                <div className="card-body p-3">
                                  <div className="d-flex align-items-center justify-content-between mb-3">
                                    <h6 className={`mb-0 fw-bold text-dark`}>
                                      Segment {segment.segment_index}
                                      {selectedSegment === index && (
                                        <span className="ms-2">
                                          <i className="ti-target" title="Currently tracking"></i>
                                        </span>
                                      )}
                                    </h6>
                                    <div className="d-flex gap-2 align-items-center">
                                      <span className={`badge bg-danger text-white`}>
                                        {segment.flight_number}
                                      </span>
                                      {selectedSegment === index && isFlightLoading && (
                                        <div className="spinner-border spinner-border-sm text-dark" role="status">
                                          <span className="visually-hidden">Loading...</span>
                                        </div>
                                      )}
                                    </div>
                                  </div>

                                  {/* Airport Route Display */}
                                  <div className="mb-3">
                                    <div className="row align-items-center">
                                      <div className="col-4">
                                        <div className="text-center">
                                          <div className={`fw-bold fs-5 text-dark`}>
                                            {segment.departure.airport}
                                          </div>
                                          <div className={`small text-dark`}>
                                            {/* {new Date(segment.departure.time).toLocaleTimeString('en-US', {
                                              hour: '2-digit',
                                              minute: '2-digit'
                                            })} */}
                                            {segment?.departure
                                              ? parseFlightRadarTime(segment?.departure).toLocaleTimeString([], {
                                                hour: "2-digit",
                                                minute: "2-digit",
                                              })
                                              : "N/A"}
                                            {console.log("segments123", segment?.departure.at_utc)}
                                          </div>
                                          {/* {segment.departure.terminal && (
                                            <div className={`small ${selectedSegment === index ? 'text-dark' : 'text-muted'}`}>
                                              T{segment.departure.terminal}
                                            </div>
                                          )} */}
                                        </div>
                                      </div>

                                      {/* Arc Line between airports */}
                                      <div className="col-4">
                                        <div className="d-flex flex-column align-items-center">
                                          {/* Curved line with plane */}
                                          <div className="position-relative" style={{ width: '100%', height: '30px' }}>
                                            <svg width="100%" height="30" viewBox="0 0 100 30" className="position-absolute">
                                              <path
                                                d="M 10 20 Q 50 5 90 20"
                                                stroke={'#000000'}
                                                strokeWidth="2"
                                                fill="none"
                                                strokeDasharray="3,3"
                                              />
                                            </svg>
                                            <i className={`ti-plane position-absolute text-dark`}
                                              style={{
                                                top: '8px',
                                                left: '45%',
                                                fontSize: '12px',
                                                transform: 'rotate(15deg)'
                                              }}>
                                            </i>
                                          </div>
                                          <small className={`text-dark text-center`}>
                                            {segment.duration.replace('PT', '').replace('H', 'h ').replace('M', 'm')}
                                          </small>
                                        </div>
                                      </div>

                                      <div className="col-4">
                                        <div className="text-center">
                                          <div className={`fw-bold fs-5 text-dark`}>
                                            {segment.arrival.airport}
                                          </div>
                                          <div className={`small text-dark`}>
                                            {/* {new Date(segment.arrival.at_utc).toLocaleTimeString('en-US', {
                                              hour: '2-digit',
                                              minute: '2-digit'
                                            })} */}
                                            {segment?.arrival
                                              ? parseFlightRadarTime(segment?.arrival).toLocaleTimeString([], {
                                                hour: "2-digit",
                                                minute: "2-digit",
                                              })
                                              : "N/A"}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  {/* Flight Details Row */}
                                  <div className="row text-center mb-2">
                                    <div className="col-6">
                                      <small className={'text-dark'}>Aircraft</small>
                                      <div className="fw-bold small">{segment.aircraft_type || 'N/A'}</div>
                                    </div>
                                    <div className="col-6">
                                      <small className={'text-dark'}>Stops</small>
                                      <div className="fw-bold small">{segment.stops === 0 ? 'Non-stop' : `${segment.stops} stop${segment.stops > 1 ? 's' : ''}`}</div>
                                    </div>
                                  </div>
                                  <div className="d-flex justify-content-between align-items-center mb-2">
                                  {segment.operating_carrier && (
                                    <div className="mb-2">
                                      <small className={'text-dark'}>Operated by: </small>
                                      <span className="fw-bold small">{segment.operating_carrier}</span>
                                    </div>
                                  )}

                                  <div className="bg-light rounded d-inline-block">
                                    <button
                                      className="btn btn-primary d-flex align-items-center"
                                      onClick={() => { handleTrackFlightSegment(segment, index) }}
                                    >
                                      <span className="fs-5">⟳</span>
                                    </button>
                                  </div>
                                  </div>
                                  {/* Click to track indicator */}
                                  {/* <div className="text-center d-none">
                                    <small className={'text-dark'}>
                                      <i className="ti-mouse me-1"></i>
                                      {selectedSegment === index ? 'Currently tracking this flight' : 'Click to track this flight'}
                                    </small>
                                  </div> */}
                                </div>
                              </div>

                              {/* Connection Indicator */}
                              {/* {index < flightData.segments.length - 1 && (
                                <div className="text-center my-2">
                                  <div className="d-inline-flex align-items-center">
                                    <div className="border-start border-2 border-primary" style={{ height: "20px" }}></div>
                                    <span className="mx-2 badge bg-secondary">Connection</span>
                                    <div className="border-start border-2 border-primary" style={{ height: "20px" }}></div>
                                  </div>
                                </div>
                              )} */}
                            </div>
                          ))}

                        {/* Total Journey Time */}
                        <div className="mt-3 p-2 text-dark rounded text-center" style={{ background: '#d4edda' }}>
                          <div className="fw-bold small">Total Journey Time</div>
                          <div className="small">
                            {new Date(flightData.departure_time).toLocaleDateString()} - {new Date(flightData.arrival_time).toLocaleDateString()}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Map Section - 70% width */}
                    <div
                      style={{
                        width: "70%",
                        height: "100%",
                        position: "relative"
                      }}
                    >
                      <GoogleMap
                        mapContainerStyle={{
                          width: "100%",
                          height: "100%",
                          borderRadius: "0 12px 12px 0",
                        }}
                        zoom={segmentTrackingData ? 8 : 3}
                        center={segmentTrackingData ?
                          { lat: segmentTrackingData.lastTrack.lat, lng: segmentTrackingData.lastTrack.lon } :
                          { lat: 40, lng: -40 } // Atlantic center for trans-atlantic flights
                        }
                        options={{
                          zoomControl: true,
                          mapTypeControl: false,
                          scaleControl: true,
                          streetViewControl: false,
                          rotateControl: true,
                          fullscreenControl: true,
                        }}
                      >
                        {/* Show segment tracking if a segment is selected */}
                        {segmentTrackingData && (
                          <>
                            {/* Origin Airport */}
                            <Marker
                              position={{
                                lat: parseFloat(sourceFlight?.latitude),
                                lng: parseFloat(sourceFlight?.longitude),
                              }}
                              // label={{
                              //   text: segmentTrackingData.segmentInfo.departure.airport,
                              //   color: "white",
                              //   fontSize: "12px",
                              //   fontWeight: "bold",
                              // }}
                              icon={{
                                url: "/images/srcmap.png", // or full URL
                                scaledSize: new window.google.maps.Size(30, 40), // resize image
                                anchor: new window.google.maps.Point(20, 40), // bottom center
                              }}
                              title={`Origin: ${segmentTrackingData.segmentInfo.departure.airport}`}
                            />

                            {/* Destination Airport */}
                            <Marker
                              position={{
                                lat: parseFloat(destFlight?.latitude),
                                lng: parseFloat(destFlight?.longitude),
                              }}
                              // label={{
                              //   text: segmentTrackingData.segmentInfo.arrival.airport,
                              //   color: "white",
                              //   fontSize: "12px",
                              //   fontWeight: "bold",
                              // }}
                              icon={{
                                url: "/images/destmap.png", // or full URL
                                scaledSize: new window.google.maps.Size(30, 40), // resize image
                                anchor: new window.google.maps.Point(20, 40), // bottom center
                              }}
                              title={`Destination: ${segmentTrackingData.segmentInfo.arrival.airport}`}
                            />

                            {/* Current Aircraft Position */}
                            <Marker
                              position={{
                                lat: segmentTrackingData.lastTrack.lat,
                                lng: segmentTrackingData.lastTrack.lon
                              }}
                              icon={{
                                path: "M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z",
                                fillColor: "#007bff",
                                fillOpacity: 1,
                                strokeWeight: 2,
                                strokeColor: "#ffffff",
                                scale: 2,
                                rotation: segmentTrackingData.lastTrack.track,
                                anchor: { x: 12, y: 12 }
                              }}
                              title={`${segmentTrackingData.flight_number} - Current Position`}
                            />

                            {/* Flight Path with Arc */}
                            {segmentTrackingData.path && (
                              <>
                                {/* Arc Path - simulate curved flight path */}
                                {/* <Polyline
                                  path={generateArcPath(
                                    segmentTrackingData.path[0],
                                    {
                                      lat: segmentTrackingData.lastTrack.lat,
                                      lng: segmentTrackingData.lastTrack.lon
                                    }
                                  )}
                                  options={{
                                    strokeColor: "#28a745",
                                    strokeOpacity: 0.6,
                                    strokeWeight: 3,
                                    strokeDashArray: "5,10"
                                  }}
                                /> */}

                                {/* Direct path from origin to current position */}
                                <Polyline
                                  path={segmentTrackingData.path}
                                  options={{
                                    strokeColor: "#007bff",
                                    strokeOpacity: 0.8,
                                    strokeWeight: 4,
                                    icons: [{
                                      icon: {
                                        path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                                        scale: 4,
                                        strokeColor: '#007bff'
                                      },
                                      offset: '100%'
                                    }]
                                  }}
                                />

                                {/* Remaining path to destination (dotted) */}
                                {/* <Polyline
                                  path={generateArcPath(
                                    {
                                      lat: segmentTrackingData.lastTrack.lat,
                                      lng: segmentTrackingData.lastTrack.lon
                                    },
                                    getDestinationCoordinates(segmentTrackingData.segmentInfo.arrival.airport)
                                  )}
                                  options={{
                                    strokeColor: "#dc3545",
                                    strokeOpacity: 0.4,
                                    strokeWeight: 2,
                                    strokeDashArray: "10,5"
                                  }}
                                /> */}
                              </>
                            )}
                          </>
                        )}
                      </GoogleMap>

                      {/* Segment Tracking Info Overlay */}
                      {segmentTrackingData && (
                        <div
                          className="position-absolute alert alert-info border-0 m-2 py-2 px-3"
                          style={{
                            top: "10px",
                            right: "10px",
                            zIndex: 1000,
                            background: "rgba(13, 202, 240, 0.95)",
                            borderRadius: "8px",
                            fontSize: "12px",
                            fontWeight: "500",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                            color: "white",
                            maxWidth: "250px"
                          }}
                        >
                          <div className="d-flex align-items-center justify-content-between mb-1">
                            <strong>
                              <i className="ti-plane me-1"></i>
                              {segmentTrackingData.flight_number}
                            </strong>
                            <button
                              className="btn-close btn-close-white"
                              onClick={() => {
                                setSegmentTrackingData(null);
                                setSelectedSegment(null);
                              }}
                              style={{ fontSize: '10px' }}
                            ></button>
                          </div>
                          {segmentTrackingData.isDemo && (
                            <div><small>{segmentTrackingData.demoNote}</small></div>
                          )}
                          <div>Status: <strong>{segmentTrackingData.status}</strong></div>
                          <div>Altitude: <strong>{segmentTrackingData.lastTrack.alt} ft</strong></div>
                          <div>Speed: <strong>{segmentTrackingData.lastTrack.gspeed} kt</strong></div>
                          {segmentTrackingData.progress && (
                            <div>Progress: <strong>{segmentTrackingData.progress}</strong></div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                ) : hasValidCoordinates && flightData ? (
                  // ✅ FIX #2: Only render the map if valid coordinates and flight data exist
                  <div style={{ position: "relative", width: "100%", height: "100%" }}>
                    {/* Demo Data Banner */}
                    {flightData.isDemo && (
                      <div
                        className="position-absolute alert alert-info border-0 m-2 py-2 px-3"
                        style={{
                          top: "10px",
                          left: "10px",
                          zIndex: 1000,
                          background: "rgba(13, 202, 240, 0.95)",
                          borderRadius: "8px",
                          fontSize: "12px",
                          fontWeight: "500",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                          color: "white"
                        }}
                      >
                        <i className="ti-plane me-1"></i>
                        <strong>Live Flight Demo:</strong> {flightData.demoNote}
                        <br />
                        <small>Progress: {flightData.progress} | ETA: {flightData.remaining_time}</small>
                      </div>
                    )}

                    <GoogleMap
                      mapContainerStyle={{
                        width: "100%",
                        height: "100%",
                        borderRadius: "10px",
                      }}
                      zoom={6}
                      center={{ lat: centerLat, lng: centerLng }}
                      options={{
                        zoomControl: true,
                        mapTypeControl: false,
                        scaleControl: true,
                        streetViewControl: false,
                        rotateControl: true,
                        fullscreenControl: true,
                      }}
                      onLoad={() => {
                        // ✅ FIX #3: Trigger map resize once loaded
                        setTimeout(() => {
                          if (window.google?.maps) {
                            window.google.maps.event.trigger(window, "resize");
                          }
                        }, 300);
                      }}
                    >
                      {/* Pickup Marker */}
                      {pickupLat && pickupLng && (
                        <Marker
                          key="pickup"
                          position={{ lat: pickupLat, lng: pickupLng }}
                          label={{
                            text: "S",
                            color: "white",
                            fontSize: "14px",
                            fontWeight: "bold",
                          }}
                          icon={{
                            path: window.google.maps.SymbolPath.CIRCLE,
                            scale: 8,
                            fillColor: "#28a745",
                            fillOpacity: 1,
                            strokeWeight: 2,
                            strokeColor: "#fff",
                          }}
                        />
                      )}

                      {/* Drop Marker */}
                      {/*{dropLat && dropLng && (
                <Marker
                  key="dropoff"
                  position={{ lat: dropLat, lng: dropLng }}
                  label={{
                    text: "D",
                    color: "white",
                    fontSize: "14px",
                    fontWeight: "bold",
                  }}
                  icon={{
                    path: window.google.maps.SymbolPath.CIRCLE,
                    scale: 8,
                    fillColor: "#dc3545",
                    fillOpacity: 1,
                    strokeWeight: 2,
                    strokeColor: "#fff",
                  }}
                />
              )
                }*/}

                      {/* Route Polyline */}
                      {(path.length === 2 || (flightData?.isDemo && flightData?.path?.length > 2)) && (
                        <Polyline
                          path={flightData?.isDemo ? flightData.path : path}
                          options={{
                            strokeColor: flightData?.isDemo ? "#0d6efd" : "#007bff",
                            strokeOpacity: flightData?.isDemo ? 1.0 : 0.8,
                            strokeWeight: flightData?.isDemo ? 4 : 3,
                            strokeDashArray: flightData?.isDemo ? undefined : undefined,
                          }}
                        />
                      )}

                      {/* Demo Flight: Add origin and destination markers */}
                      {flightData?.isDemo && flightData.path && flightData.path.length > 0 && (
                        <>
                          {/* Origin Airport Marker */}
                          <Marker
                            position={flightData.path[0]}
                            label={{
                              text: "JFK",
                              color: "white",
                              fontSize: "12px",
                              fontWeight: "bold",
                            }}
                            icon={{
                              path: window.google.maps.SymbolPath.CIRCLE,
                              scale: 10,
                              fillColor: "#28a745",
                              fillOpacity: 1,
                              strokeWeight: 2,
                              strokeColor: "#fff",
                            }}
                            title="Origin: JFK International Airport, New York"
                          />

                          {/* Future Destination (where plane is heading) */}
                          <Marker
                            position={{ lat: 51.4700, lng: -0.4543 }}
                            label={{
                              text: "LHR",
                              color: "white",
                              fontSize: "12px",
                              fontWeight: "bold",
                            }}
                            icon={{
                              path: window.google.maps.SymbolPath.CIRCLE,
                              scale: 10,
                              fillColor: "#dc3545",
                              fillOpacity: 1,
                              strokeWeight: 2,
                              strokeColor: "#fff",
                            }}
                            title="Destination: Heathrow Airport, London"
                          />
                        </>
                      )}

                      {/* ✈️ Flight Marker */}
                      {flightData?.lastTrack &&
                        flightData.lastTrack.lat &&
                        flightData.lastTrack.lon && (
                          <Marker
                            key="flight"
                            position={{
                              lat: flightData.lastTrack.lat,
                              lng: flightData.lastTrack.lon,
                            }}
                            icon={{
                              url: "/images/showflight.png",
                              scaledSize: flightData.isDemo ?
                                new window.google.maps.Size(50, 50) :
                                new window.google.maps.Size(40, 40),
                              anchor: flightData.isDemo ?
                                new window.google.maps.Point(25, 25) :
                                new window.google.maps.Point(20, 20),
                            }}
                            title={`Flight: ${currentFlightInfo?.flight_no || booking?.quote?.flight_no || 'Unknown'} ${flightData.lastTrack.callsign}${flightData.isDemo ? ' (Live Demo)' : ''}\nAltitude: ${flightData.lastTrack.alt} ft\nSpeed: ${flightData.lastTrack.gspeed} kts${flightData.isDemo ? `\n📍 Currently over Atlantic Ocean\n⏱️ ETA: ${flightData.remaining_time}` : ''}`}
                            animation={flightData.isDemo ? window.google?.maps?.Animation?.BOUNCE : undefined}
                          />
                        )}
                    </GoogleMap>
                  </div>
                ) : (
                  <div className="d-flex justify-content-center align-items-center h-100">
                    <h6 className="text-muted">Awaiting flight data...</h6>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Delivery Person Tracking Modal */}
      <div
        className="modal fade commen-popup"
        id="DeliveryTrackModalToggle"
        tabIndex="-1"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-xl modal-dialog-centered"
          style={{
            width: "calc(100% - 40px)",
            height: "calc(100% - 40px)",
            margin: "20px",
            maxWidth: "none",
          }}
        >
          <div
            className="modal-content"
            style={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              className="modal-body p-0 position-relative flex-grow-1"
              style={{ height: "100%", overflow: "hidden" }}
            >
              {/* Close Button */}
              <button
                type="button"
                className="btn-close position-absolute bg-white rounded-circle p-2 shadow"
                data-bs-dismiss="modal"
                aria-label="Close"
                style={{
                  top: "15px",
                  right: "15px",
                  zIndex: 9999,
                  border: "2px solid #ddd",
                }}
              ></button>

              {/* Delivery Person Tracking Map */}
              <div style={{ height: "100%", width: "100%" }}>
                {!isLoaded ? (
                  <div className="d-flex justify-content-center align-items-center h-100">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading map...</span>
                    </div>
                    <span className="ms-2">Loading delivery tracking...</span>
                  </div>
                ) : (
                  <div className="delivery-tracking-container h-100">
                    {/* Map Container */}
                    <div className="row h-100 g-0">
                      <div className="col-md-8 h-100">
                        <GoogleMap
                          onLoad={(map) => (mapRef.current = map)}
                          mapContainerStyle={{
                            width: "100%",
                            height: "100%",
                            borderRadius: "10px 0 0 10px",
                          }}
                          zoom={8}
                          center={{
                            lat: currentStage?.origin_lat,
                            lng: currentStage?.origin_long
                          }}
                          options={{
                            zoomControl: true,
                            mapTypeControl: false,
                            scaleControl: true,
                            streetViewControl: false,
                            rotateControl: true,
                            fullscreenControl: false,
                          }}
                        >
                          {/* Pickup Location */}
                          {currentStage?.origin_lat && (
                            <Marker
                              key="pickup"
                              position={{
                                lat: parseFloat(currentStage?.origin_lat),
                                lng: parseFloat(currentStage?.origin_long)
                              }}
                              // label={{
                              //   text: "P",
                              //   color: "white",
                              //   fontSize: "14px",
                              //   fontWeight: "bold",
                              // }}
                              icon={{
                                url: "/images/srcmap.png", // or full URL
                                scaledSize: new window.google.maps.Size(30, 40), // resize image
                                anchor: new window.google.maps.Point(20, 40), // bottom center
                              }}
                              title="Pickup Location"
                            />
                          )}

                          {/* Dropoff Location */}
                          {currentStage?.destination_lat && (
                            <Marker
                              key="dropoff"
                              position={{
                                lat: parseFloat(currentStage?.destination_lat) || currentLocation.lat,
                                lng: parseFloat(currentStage?.destination_long) || currentLocation.lng
                              }}
                              // label={{
                              //   text: "D",
                              //   color: "white",
                              //   fontSize: "14px",
                              //   fontWeight: "bold",
                              // }}
                              icon={{
                                url: "/images/destmap.png", // or full URL
                                scaledSize: new window.google.maps.Size(30, 40), // resize image
                                anchor: new window.google.maps.Point(20, 40), // bottom center
                              }}
                              title="Delivery Location"
                            />
                          )}

                          <Marker
                            position={{
                              lat: Number(currentStage?.origin_lat),
                              lng: Number(currentStage?.origin_long)
                            }}
                            icon={{
                              url: "/images/plane-icon.png",
                              scaledSize: new window.google.maps.Size(40, 40),
                            }}
                          />

                          {/* Route Polyline between pickup and dropoff */}
                          {currentStage?.origin_lat && currentStage?.destination_lat && (
                            <Polyline
                              path={[
                                {
                                  lat: parseFloat(currentStage?.origin_lat) || currentLocation.lat,
                                  lng: parseFloat(currentStage?.origin_long) || currentLocation.lng
                                },
                                {
                                  lat: parseFloat(currentStage?.destination_lat) || currentLocation.lat,
                                  lng: parseFloat(currentStage?.destination_long) || currentLocation.lng
                                }
                              ]}
                              options={{
                                strokeColor: "#007bff",
                                strokeOpacity: 0.8,
                                strokeWeight: 4,
                                strokeDashArray: [10, 5],
                              }}
                            />
                          )}

                          {providerLat && providerLng && (
                            <Marker
                              position={{ lat: providerLat, lng: providerLng }}
                              icon={{
                                url: "/images/img-01.png",
                                scaledSize: new window.google.maps.Size(40, 40),
                              }}
                            />
                          )}

                          {/* Dotted line from delivery person to pickup location */}
                          {pickupAddress && (
                            <Polyline
                              path={[
                                {
                                  lat: (parseFloat(pickupAddress?.latitude) || currentLocation.lat) + 0.005,
                                  lng: (parseFloat(pickupAddress?.longitude) || currentLocation.lng) + 0.005
                                },
                                {
                                  lat: parseFloat(pickupAddress.latitude) || currentLocation.lat,
                                  lng: parseFloat(pickupAddress.longitude) || currentLocation.lng
                                }
                              ]}
                              options={{
                                strokeColor: "#28a745",
                                strokeOpacity: 0.6,
                                strokeWeight: 2,
                                strokeDashArray: [5, 5],
                              }}
                            />
                          )}

                          {/* Dotted line from delivery person to dropoff location */}
                          {dropoffAddress && (
                            <Polyline
                              path={[
                                {
                                  lat: (parseFloat(pickupAddress?.latitude) || currentLocation.lat) + 0.005,
                                  lng: (parseFloat(pickupAddress?.longitude) || currentLocation.lng) + 0.005
                                },
                                {
                                  lat: parseFloat(dropoffAddress.latitude) || currentLocation.lat,
                                  lng: parseFloat(dropoffAddress.longitude) || currentLocation.lng
                                }
                              ]}
                              options={{
                                strokeColor: "#dc3545",
                                strokeOpacity: 0.6,
                                strokeWeight: 2,
                                strokeDashArray: [5, 5],
                              }}
                            />
                          )}

                          {/* Delivery Person Location (simulated) */}
                          <Marker
                            key="delivery-person"
                            position={{
                              lat: (parseFloat(pickupAddress?.latitude) || currentLocation.lat) + 0.005,
                              lng: (parseFloat(pickupAddress?.longitude) || currentLocation.lng) + 0.005
                            }}
                            icon={{
                              url: "/images/delivery-truck.png",
                              scaledSize: new window.google.maps.Size(40, 40),
                              anchor: new window.google.maps.Point(20, 20),
                            }}
                            title="Delivery Person Current Location"
                          />

                          {/* Route Info Popup - Custom Overlay */}
                          {currentRouteData && pickupAddress && dropoffAddress && showRouteInfoWindow && (
                            <div
                              className="route-info-overlay"
                              style={{
                                position: 'absolute',
                                top: '10px',
                                right: '10px',
                                background: 'white',
                                padding: '12px',
                                borderRadius: '8px',
                                boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
                                maxWidth: '280px',
                                zIndex: 1000,
                                border: '1px solid #ddd'
                              }}
                            >
                              <div className="d-flex justify-content-between align-items-center mb-2">
                                <h6 className="mb-0 text-primary">
                                  <i className="ti-route me-1"></i>
                                  Active Delivery Route
                                </h6>
                                <button
                                  className="btn-close btn-sm"
                                  onClick={() => setShowRouteInfoWindow(false)}
                                  style={{ fontSize: '10px' }}
                                ></button>
                              </div>
                              <div className="small">
                                <div className="mb-1">
                                  <strong>Distance:</strong> {currentRouteData.distance} km
                                </div>
                                <div className="mb-1">
                                  <strong>From:</strong> {currentRouteData.origin.substring(0, 30)}...
                                </div>
                                <div className="mb-1">
                                  <strong>To:</strong> {currentRouteData.destination.substring(0, 30)}...
                                </div>
                                <div>
                                  <strong>Driver:</strong> {currentRouteData.serviceProvider?.full_name}
                                </div>
                              </div>
                            </div>
                          )}
                        </GoogleMap>
                      </div>

                      {/* Delivery Info Panel */}
                      <div className="col-md-4 h-100 bg-light p-4" style={{ overflowY: 'auto' }}>
                        <div className="delivery-info">
                          <h4 className="mb-3">
                            <i className="ti-truck me-2 text-warning"></i>
                            Live Delivery Tracking
                          </h4>

                          {/* Route Information */}
                          {currentRouteData && (
                            <div className="route-info-card mb-4 p-3 bg-white rounded shadow-sm">
                              <h6 className="mb-3">
                                <i className="ti-route me-2 text-primary"></i>
                                Route Information
                              </h6>
                              <div className="route-details">
                                <div className="mb-2">
                                  <small className="text-muted">From:</small>
                                  <div className="fw-bold text-success">
                                    <i className="ti-location-pin me-1"></i>
                                    {currentRouteData.origin}
                                  </div>
                                </div>
                                <div className="mb-2">
                                  <small className="text-muted">To:</small>
                                  <div className="fw-bold text-success">
                                    <i className="ti-flag me-1"></i>
                                    {currentRouteData.destination}
                                  </div>
                                </div>
                                <div className="mb-2">
                                  <small className="text-muted">Distance:</small> <span className="fw-bold text-info"><i className="ti-ruler-alt me-1"></i>
                                    {currentRouteData.distance} km </span>
                                </div>
                                <div className="row">
                                  <div className="col-6">
                                    <small className="text-muted">Pickup Date:</small>
                                    <div className="fw-bold text-primary">
                                      {currentRouteData.pickupDate}
                                    </div>
                                  </div>
                                  <div className="col-6">
                                    <small className="text-muted">Drop Date:</small>
                                    <div className="fw-bold text-primary">
                                      {currentRouteData.dropDate}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          {/* Delivery Person Info */}
                          {(() => {
                            // Find the most recent stage with a service provider
                            const latestStageWithProvider = stageStatus
                              .flatMap(stageGroup => stageGroup.stages || [])
                              .filter(stage => stage.service_provider)
                              .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))[0];

                            if (!latestStageWithProvider) {
                              return (
                                <div className="delivery-person-card mb-4 p-3 bg-white rounded shadow-sm">
                                  <div className="text-center text-muted">
                                    <i className="ti-truck mb-2" style={{ fontSize: '24px' }}></i>
                                    <p className="mb-0">No active delivery partner assigned yet</p>
                                  </div>
                                </div>
                              );
                            }

                            const { service_provider, status, created_at } = latestStageWithProvider;
                            const statusBadgeClass = status === 'Accepted' ? 'bg-primary' :
                              status === 'Pickup' ? 'bg-info' :
                                status === 'InTransit' ? 'bg-warning' : 'bg-success';

                            return (
                              <div className="delivery-person-card mb-4 p-3 bg-white rounded shadow-sm">
                                <div className="d-flex align-items-center mb-3">
                                  <div className="delivery-avatar me-3">
                                    {service_provider.sp_profile_image ? (
                                      <img
                                        src={service_provider.sp_profile_image}
                                        alt={service_provider.full_name}
                                        className="rounded-circle"
                                        style={{ width: '40px', height: '40px', objectFit: 'cover' }}
                                      />
                                    ) : (
                                      <i className="ti-user bg-success text-white rounded-circle p-2" style={{ fontSize: '24px' }}></i>
                                    )}
                                  </div>
                                  <div>
                                    <h6 className="mb-0">{service_provider.full_name}</h6>
                                    <small className="text-muted">Delivery Partner</small>
                                    <div className="mt-1">
                                      <span className={`badge ${statusBadgeClass} badge-sm`}>
                                        {status}
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                <div className="contact-actions d-flex gap-2 mb-3">
                                  {service_provider.mobile_number ? (
                                    <a
                                      href={`tel:${service_provider.mobile_number}`}
                                      className="btn btn-success btn-sm flex-fill"
                                    >
                                      <i className="ti-phone me-1"></i>Call
                                    </a>
                                  ) : (
                                    <button className="btn btn-secondary btn-sm flex-fill" disabled>
                                      <i className="ti-phone me-1"></i>No Number
                                    </button>
                                  )}
                                  <a href="#" className="btn btn-info btn-sm">
                                    <i className="ti-message me-1"></i>Chat
                                  </a>
                                </div>

                                <div className="delivery-status">
                                  <div className="d-flex justify-content-between align-items-center mb-2">
                                    <span className="small">Status:</span>
                                    <span className={`badge ${statusBadgeClass}`}>
                                      {status}
                                    </span>
                                  </div>
                                  <div className="d-flex justify-content-between align-items-center mb-2">
                                    <span className="small">Last Updated:</span>
                                    <span className="fw-bold small">
                                      {new Date(created_at).toLocaleString('en-GB')}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            );
                          })()}


                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade commen-popup"
        id="OtpModalToggle"
        aria-hidden="true"
        aria-labelledby="OtpModalToggleLabel"
        tabIndex="-1"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body" style={{ display: 'list-item' }}>
              <div className="row">
                <div className="col-lg-6">
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={() => handleCloseModal("OtpModalToggle")}
                  ></button>

                  <h5 className="mt-2">Enter OTP</h5>
                  <p>Please check your emails, including the spam folder, for the one time password we sent you.</p>

                  <form onSubmit={handleOTPSubmit}>
                    <div className="d-flex gap-2 mb-3">
                      {otp.map((digit, idx) => (
                        <input
                          key={idx}
                          type="text"
                          className="form-control text-center"
                          maxLength={1}
                          value={digit}
                          onChange={(e) => handleChangeOTP(e, idx)}
                          onKeyDown={(e) => handleBackspace(e, idx)}
                          ref={(el) => (inputsRef.current[idx] = el)}
                        />
                      ))}
                    </div>

                    <div className="col-md-12 gap-2 mb-3 d-flex">

                      <button
                        type="submit"
                        className="eagle-btn text-center w-50"
                        disabled={loading}
                      >
                        {loading ? "Verifying..." : "VERIFY"}
                      </button>
                    </div>
                    <div className="mb-2">
                      Didn't receive an OTP?{" "}
                      <button
                        type="button"
                        className="btn btn-link p-0"
                        // onClick={handleResendOTP}
                        disabled={loading}
                      >
                        {loading ? "Resending..." : "Resend"}
                      </button>
                    </div>

                  </form>
                </div>

                <div className="col-lg-6">
                  <img
                    src="images/banner-slider-img/1.jpg"
                    className="img-fluid"
                    alt="banner"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingDetails;